import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _20fa2d4e = () => interopDefault(import('../../../views/calculations/detail.vue' /* webpackChunkName: "" */))
const _ba281fd6 = () => interopDefault(import('../../../views/campaigns/detail.vue' /* webpackChunkName: "" */))
const _00ef9b12 = () => interopDefault(import('../../../views/products/product-detail.vue' /* webpackChunkName: "" */))
const _d218fbec = () => interopDefault(import('../../../views/support-announcements/detail.vue' /* webpackChunkName: "" */))
const _43bf8176 = () => interopDefault(import('../../../views/blog/detail.vue' /* webpackChunkName: "" */))
const _d6aa06ae = () => interopDefault(import('../../../views/landing-pages/index.vue' /* webpackChunkName: "" */))
const _699a505f = () => interopDefault(import('../../../views/pages/index.vue' /* webpackChunkName: "" */))
const _2570bee5 = () => interopDefault(import('../../../views/calculations/index.vue' /* webpackChunkName: "" */))
const _be3c97e0 = () => interopDefault(import('../../../views/sitemap/index.vue' /* webpackChunkName: "" */))
const _fbf08412 = () => interopDefault(import('../../../views/contact-us/success.vue' /* webpackChunkName: "" */))
const _3a922e46 = () => interopDefault(import('../../../views/contact-us/index.vue' /* webpackChunkName: "" */))
const _4268073e = () => interopDefault(import('../../../views/campaigns/index.vue' /* webpackChunkName: "" */))
const _c6483aae = () => interopDefault(import('../../../views/support-announcements/index.vue' /* webpackChunkName: "" */))
const _d773d390 = () => interopDefault(import('../../../views/support-after-sales/index.vue' /* webpackChunkName: "" */))
const _b334cf10 = () => interopDefault(import('../../../views/support-home/index.vue' /* webpackChunkName: "" */))
const _11e29cdd = () => interopDefault(import('../../../views/support-product-version-updates/indexvHS.vue' /* webpackChunkName: "" */))
const _2dced710 = () => interopDefault(import('../../../views/support-product-version-updates/indexv17.vue' /* webpackChunkName: "" */))
const _a364c082 = () => interopDefault(import('../../../views/support-product-version-updates/detail.vue' /* webpackChunkName: "" */))
const _c4c68b58 = () => interopDefault(import('../../../views/support-product-version-updates/index.vue' /* webpackChunkName: "" */))
const _e1be75d0 = () => interopDefault(import('../../../views/verticals/index.vue' /* webpackChunkName: "" */))
const _10483204 = () => interopDefault(import('../../../views/solutions/detail.vue' /* webpackChunkName: "" */))
const _13990f35 = () => interopDefault(import('../../../views/solutions/index.vue' /* webpackChunkName: "" */))
const _5f3a2e5e = () => interopDefault(import('../../../views/partners/partners-listing.vue' /* webpackChunkName: "" */))
const _639d55d8 = () => interopDefault(import('../../../views/partners/partner-resources.vue' /* webpackChunkName: "" */))
const _62ae37b3 = () => interopDefault(import('../../../views/partners/partner-program.vue' /* webpackChunkName: "" */))
const _52a2cdc0 = () => interopDefault(import('../../../views/mikro-brand-identity/index.vue' /* webpackChunkName: "" */))
const _0afed065 = () => interopDefault(import('../../../views/partners/partner-brand-identity.vue' /* webpackChunkName: "" */))
const _4a561816 = () => interopDefault(import('../../../views/partners/partner-api-request-form-two.vue' /* webpackChunkName: "" */))
const _2d27f376 = () => interopDefault(import('../../../views/partners/partner-api-request-form.vue' /* webpackChunkName: "" */))
const _11c9d7b6 = () => interopDefault(import('../../../views/partners/partner-form.vue' /* webpackChunkName: "" */))
const _589c5514 = () => interopDefault(import('../../../views/legal/index.vue' /* webpackChunkName: "" */))
const _3423a28e = () => interopDefault(import('../../../views/products/edonusum-listing.vue' /* webpackChunkName: "" */))
const _249a739e = () => interopDefault(import('../../../views/products/products-by-size.vue' /* webpackChunkName: "" */))
const _0b0091ac = () => interopDefault(import('../../../views/products/products-by-industries.vue' /* webpackChunkName: "" */))
const _225fc774 = () => interopDefault(import('../../../views/products/products-by-need.vue' /* webpackChunkName: "" */))
const _2adb6382 = () => interopDefault(import('../../../views/product-comparison/index.vue' /* webpackChunkName: "" */))
const _355b21bb = () => interopDefault(import('../../../views/contact/index.vue' /* webpackChunkName: "" */))
const _0bd165f0 = () => interopDefault(import('../../../views/about-us/career-at-mikro.vue' /* webpackChunkName: "" */))
const _1bb76077 = () => interopDefault(import('../../../views/about-us/working-at-mikro.vue' /* webpackChunkName: "" */))
const _3ba25728 = () => interopDefault(import('../../../views/about-us/human-resources.vue' /* webpackChunkName: "" */))
const _4336e7a7 = () => interopDefault(import('../../../views/about-us/success-stories-listing.vue' /* webpackChunkName: "" */))
const _905d5520 = () => interopDefault(import('../../../views/about-us/success-stories.vue' /* webpackChunkName: "" */))
const _581c45bd = () => interopDefault(import('../../../views/blog/index.vue' /* webpackChunkName: "" */))
const _572b4b4d = () => interopDefault(import('../../../views/blog/search.vue' /* webpackChunkName: "" */))
const _20762fe0 = () => interopDefault(import('../../../views/about-us/sustainability.vue' /* webpackChunkName: "" */))
const _8818fdcc = () => interopDefault(import('../../../views/about-us/customer-obsessed.vue' /* webpackChunkName: "" */))
const _2e070f62 = () => interopDefault(import('../../../views/why-mikro/index.vue' /* webpackChunkName: "" */))
const _add53e2c = () => interopDefault(import('../../../views/index.vue' /* webpackChunkName: "" */))
const _c02ce4a6 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/maas-hesaplama",
    component: _20fa2d4e,
    name: "maas-hesaplama-320"
  }, {
    path: "/kdv-hesaplama",
    component: _20fa2d4e,
    name: "kdv-hesaplama-157"
  }, {
    path: "/smm-hesaplama",
    component: _20fa2d4e,
    name: "smm-hesaplama-246"
  }, {
    path: "/kira-stopaj-hesaplama",
    component: _20fa2d4e,
    name: "kira-stopaj-hesaplama-287"
  }, {
    path: "/amortisman-hesaplama",
    component: _20fa2d4e,
    name: "amortisman-hesaplama-348"
  }, {
    path: "/gelir-vergisi-hesaplama",
    component: _20fa2d4e,
    name: "gelir-vergisi-hesaplama-163"
  }, {
    path: "/e-fatura-mukellefi-miyim",
    component: _20fa2d4e,
    name: "e-fatura-mukellefi-miyim-149"
  }, {
    path: "/mayis-indirim-2026",
    component: _ba281fd6,
    name: "mayis-indirim-2026-146"
  }, {
    path: "/mikrosu-var",
    component: _ba281fd6,
    name: "mikrosu-var-45"
  }, {
    path: "/tam-finans-mobil-entegrasyonu",
    component: _ba281fd6,
    name: "tam-finans-mobil-entegrasyonu-453"
  }, {
    path: "/mikro-yazilim-ve-turkkep-isbirligi-ile-kep-basvurularini-kolaylastirdik",
    component: _ba281fd6,
    name: "mikro-yazilim-ve-turkkep-isbirligi-ile-kep-basvurularini-kolaylastirdik-463"
  }, {
    path: "/aradiginiz-cozum",
    component: _ba281fd6,
    name: "aradiginiz-cozum-316"
  }, {
    path: "/arkadasini-getir-kampanyasi",
    component: _ba281fd6,
    name: "arkadasini-getir-kampanyasi-117"
  }, {
    path: "/mukellefini-getir-kampanyasi",
    component: _ba281fd6,
    name: "mukellefini-getir-kampanyasi-135"
  }, {
    path: "/kalite-yonetim-sistemi-politikamiz",
    component: _ba281fd6,
    name: "kalite-yonetim-sistemi-politikamiz-164"
  }, {
    path: "/plastik-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "plastik-sektoru-icin-muhasebe-cozumleri-121"
  }, {
    path: "/evrak-takip-programi",
    component: _00ef9b12,
    name: "evrak-takip-programi-353"
  }, {
    path: "/teknik-servis-programi",
    component: _00ef9b12,
    name: "teknik-servis-programi-279"
  }, {
    path: "/erp-programlari",
    component: _00ef9b12,
    name: "erp-programlari-293"
  }, {
    path: "/mikro-versiyon-v17",
    component: _00ef9b12,
    name: "mikro-versiyon-v17-192"
  }, {
    path: "/personel-devam-programi",
    component: _00ef9b12,
    name: "personel-devam-programi-211"
  }, {
    path: "/borc-takip-programi",
    component: _00ef9b12,
    name: "borc-takip-programi-140"
  }, {
    path: "/gelismis-fason-yonetimi",
    component: _00ef9b12,
    name: "gelismis-fason-yonetimi-241"
  }, {
    path: "/barkod-okuma-sistemi",
    component: _00ef9b12,
    name: "barkod-okuma-sistemi-342"
  }, {
    path: "/entegre-muhasebe-programi",
    component: _00ef9b12,
    name: "entegre-muhasebe-programi-15"
  }, {
    path: "/market-otomasyon-programi",
    component: _00ef9b12,
    name: "market-otomasyon-programi-378"
  }, {
    path: "/mikro-jump-basic",
    component: _00ef9b12,
    name: "mikro-jump-basic-3"
  }, {
    path: "/e-fatura-programi",
    component: _00ef9b12,
    name: "e-fatura-programi-8"
  }, {
    path: "/fis-yazdirma-programi",
    component: _00ef9b12,
    name: "fis-yazdirma-programi-195"
  }, {
    path: "/perakende-otomasyon-sistemi",
    component: _00ef9b12,
    name: "perakende-otomasyon-sistemi-122"
  }, {
    path: "/gelir-gider-programi",
    component: _00ef9b12,
    name: "gelir-gider-programi-448"
  }, {
    path: "/tahsilat-makbuz-programi",
    component: _00ef9b12,
    name: "tahsilat-makbuz-programi-111"
  }, {
    path: "/musteri-kayit-programi",
    component: _00ef9b12,
    name: "musteri-kayit-programi-437"
  }, {
    path: "/mikro-jump-bulut",
    component: _00ef9b12,
    name: "mikro-jump-bulut-293"
  }, {
    path: "/isci-maasi-hesaplama-programi",
    component: _00ef9b12,
    name: "isci-maasi-hesaplama-programi-81"
  }, {
    path: "/masraf-yonetimi-programi",
    component: _00ef9b12,
    name: "masraf-yonetimi-programi-481"
  }, {
    path: "/e-ticaret-muhasebe-programi",
    component: _00ef9b12,
    name: "e-ticaret-muhasebe-programi-468"
  }, {
    path: "/alacak-takibi",
    component: _00ef9b12,
    name: "alacak-takibi-472"
  }, {
    path: "/amortisman-hesaplama-programi",
    component: _00ef9b12,
    name: "amortisman-hesaplama-programi-422"
  }, {
    path: "/hesap-takip-programi",
    component: _00ef9b12,
    name: "hesap-takip-programi-373"
  }, {
    path: "/yazilim-programlari",
    component: _00ef9b12,
    name: "yazilim-programlari-144"
  }, {
    path: "/is-takip-programi",
    component: _00ef9b12,
    name: "is-takip-programi-455"
  }, {
    path: "/mikro-run",
    component: _00ef9b12,
    name: "mikro-run-101"
  }, {
    path: "/odeme-takip-programi",
    component: _00ef9b12,
    name: "odeme-takip-programi-222"
  }, {
    path: "/perakende-satis-ve-magaza-yonetimi-programi",
    component: _00ef9b12,
    name: "perakende-satis-ve-magaza-yonetimi-programi-251"
  }, {
    path: "/e-ticaret-muhasebe-programi",
    component: _00ef9b12,
    name: "e-ticaret-muhasebe-programi-406"
  }, {
    path: "/musteri-takip-programi",
    component: _00ef9b12,
    name: "musteri-takip-programi-305"
  }, {
    path: "/muhasebe-kayit-programi",
    component: _00ef9b12,
    name: "muhasebe-kayit-programi-413"
  }, {
    path: "/taksitli-satis-programi",
    component: _00ef9b12,
    name: "taksitli-satis-programi-150"
  }, {
    path: "/stok-takip-programi",
    component: _00ef9b12,
    name: "stok-takip-programi-98"
  }, {
    path: "/satis-takip-programi",
    component: _00ef9b12,
    name: "satis-takip-programi-44"
  }, {
    path: "/urun-takip-sistemi-programi",
    component: _00ef9b12,
    name: "urun-takip-sistemi-programi-29"
  }, {
    path: "/restaurant-muhasebe-programi",
    component: _00ef9b12,
    name: "restaurant-muhasebe-programi-112"
  }, {
    path: "/uretim-takip-programi",
    component: _00ef9b12,
    name: "uretim-takip-programi-49"
  }, {
    path: "/hesap-tutma-programi",
    component: _00ef9b12,
    name: "hesap-tutma-programi-21"
  }, {
    path: "/perakende-satis-yazilimi",
    component: _00ef9b12,
    name: "perakende-satis-yazilimi-324"
  }, {
    path: "/kurumsal-tahsilat-programi",
    component: _00ef9b12,
    name: "kurumsal-tahsilat-programi-148"
  }, {
    path: "/Tahsilat-programi",
    component: _00ef9b12,
    name: "Tahsilat-programi-385"
  }, {
    path: "/insaat-muhasebe-programlari",
    component: _00ef9b12,
    name: "insaat-muhasebe-programlari-407"
  }, {
    path: "/ihracat-programi",
    component: _00ef9b12,
    name: "ihracat-programi-228"
  }, {
    path: "/stok-tutma-programi",
    component: _00ef9b12,
    name: "stok-tutma-programi-450"
  }, {
    path: "/satin-alma-yonetimi",
    component: _00ef9b12,
    name: "satin-alma-yonetimi-227"
  }, {
    path: "/kasa-satis-programi",
    component: _00ef9b12,
    name: "kasa-satis-programi-317"
  }, {
    path: "/teklif-hazirlama-programi",
    component: _00ef9b12,
    name: "teklif-hazirlama-programi-444"
  }, {
    path: "/web-tabanli-stok-takip-programi",
    component: _00ef9b12,
    name: "web-tabanli-stok-takip-programi-469"
  }, {
    path: "/tahsilat-programlari",
    component: _00ef9b12,
    name: "tahsilat-programlari-238"
  }, {
    path: "/kirtasiye-barkod-sistemi-yonetimi",
    component: _00ef9b12,
    name: "kirtasiye-barkod-sistemi-yonetimi-168"
  }, {
    path: "/magaza-satis-programi",
    component: _00ef9b12,
    name: "magaza-satis-programi-433"
  }, {
    path: "/yillik-izin-programi",
    component: _00ef9b12,
    name: "yillik-izin-programi-408"
  }, {
    path: "/yedek-parca-programi",
    component: _00ef9b12,
    name: "yedek-parca-programi-157"
  }, {
    path: "/hizli-satis-programi",
    component: _00ef9b12,
    name: "hizli-satis-programi-449"
  }, {
    path: "/market-muhasebe-programi",
    component: _00ef9b12,
    name: "market-muhasebe-programi-386"
  }, {
    path: "/personel-programi",
    component: _00ef9b12,
    name: "personel-programi-76"
  }, {
    path: "/satis-stok-takip-programi",
    component: _00ef9b12,
    name: "satis-stok-takip-programi-198"
  }, {
    path: "/satis-yonetim-programi",
    component: _00ef9b12,
    name: "satis-yonetim-programi-296"
  }, {
    path: "/urun-satis-programi",
    component: _00ef9b12,
    name: "urun-satis-programi-67"
  }, {
    path: "/ticari-muhasebe-programi",
    component: _00ef9b12,
    name: "ticari-muhasebe-programi-493"
  }, {
    path: "/vardiya-programi",
    component: _00ef9b12,
    name: "vardiya-programi-270"
  }, {
    path: "/planlama-programi",
    component: _00ef9b12,
    name: "planlama-programi-494"
  }, {
    path: "/pompa-hesabi-programi",
    component: _00ef9b12,
    name: "pompa-hesabi-programi-55"
  }, {
    path: "/muhasebe-programi",
    component: _00ef9b12,
    name: "muhasebe-programi-456"
  }, {
    path: "/finans-yonetimi-programi",
    component: _00ef9b12,
    name: "finans-yonetimi-programi-83"
  }, {
    path: "/sozlesme-programi",
    component: _00ef9b12,
    name: "sozlesme-programi-461"
  }, {
    path: "/veresiye-programi",
    component: _00ef9b12,
    name: "veresiye-programi-447"
  }, {
    path: "/fatura-kesim-programi",
    component: _00ef9b12,
    name: "fatura-kesim-programi-494"
  }, {
    path: "/tedarikci-yonetimi-programi",
    component: _00ef9b12,
    name: "tedarikci-yonetimi-programi-415"
  }, {
    path: "/taksit-takip-programi",
    component: _00ef9b12,
    name: "taksit-takip-programi-280"
  }, {
    path: "/urun-yonetimi-programi",
    component: _00ef9b12,
    name: "urun-yonetimi-programi-229"
  }, {
    path: "/siparis-takip-programi",
    component: _00ef9b12,
    name: "siparis-takip-programi-71"
  }, {
    path: "/mikro-market-programi",
    component: _00ef9b12,
    name: "mikro-market-programi-23"
  }, {
    path: "/saat-ucretinden-maas-hesaplama-programi",
    component: _00ef9b12,
    name: "saat-ucretinden-maas-hesaplama-programi-380"
  }, {
    path: "/market-yazilim-programi",
    component: _00ef9b12,
    name: "market-yazilim-programi-51"
  }, {
    path: "/teklif-takip-programi",
    component: _00ef9b12,
    name: "teklif-takip-programi-173"
  }, {
    path: "/hizmet-yonetimi-programi",
    component: _00ef9b12,
    name: "hizmet-yonetimi-programi-182"
  }, {
    path: "/giyim-magazasi-satis-programi",
    component: _00ef9b12,
    name: "giyim-magazasi-satis-programi-210"
  }, {
    path: "/depo-sayim-programi",
    component: _00ef9b12,
    name: "depo-sayim-programi-468"
  }, {
    path: "/puantaj-programi",
    component: _00ef9b12,
    name: "puantaj-programi-197"
  }, {
    path: "/isletme-defteri-programi",
    component: _00ef9b12,
    name: "isletme-defteri-programi-135"
  }, {
    path: "/uretim-planlama-programi",
    component: _00ef9b12,
    name: "uretim-planlama-programi-458"
  }, {
    path: "/maas-programi",
    component: _00ef9b12,
    name: "maas-programi-325"
  }, {
    path: "/maas-hesaplama-programi",
    component: _00ef9b12,
    name: "maas-hesaplama-programi-284"
  }, {
    path: "/cek-senet-programi",
    component: _00ef9b12,
    name: "cek-senet-programi-26"
  }, {
    path: "/isci-bordrosu-programi",
    component: _00ef9b12,
    name: "isci-bordrosu-programi-255"
  }, {
    path: "/imalat-muhasebe-programi",
    component: _00ef9b12,
    name: "imalat-muhasebe-programi-338"
  }, {
    path: "/mali-analiz-programi",
    component: _00ef9b12,
    name: "mali-analiz-programi-2"
  }, {
    path: "/malzeme-takip-programi",
    component: _00ef9b12,
    name: "malzeme-takip-programi-196"
  }, {
    path: "/beyanname-programi",
    component: _00ef9b12,
    name: "beyanname-programi-178"
  }, {
    path: "/maas-iadesi-hesaplama-programi",
    component: _00ef9b12,
    name: "maas-iadesi-hesaplama-programi-116"
  }, {
    path: "/mobilya-uretim-takip-programi",
    component: _00ef9b12,
    name: "mobilya-uretim-takip-programi-188"
  }, {
    path: "/magaza-stok-takip-programi",
    component: _00ef9b12,
    name: "magaza-stok-takip-programi-452"
  }, {
    path: "/magaza-kasa-programlari",
    component: _00ef9b12,
    name: "magaza-kasa-programlari-323"
  }, {
    path: "/market-programi",
    component: _00ef9b12,
    name: "market-programi-303"
  }, {
    path: "/market-yazilimi",
    component: _00ef9b12,
    name: "market-yazilimi-393"
  }, {
    path: "/irsaliye-programi",
    component: _00ef9b12,
    name: "irsaliye-programi-444"
  }, {
    path: "/magaza-otomasyon-sistemleri",
    component: _00ef9b12,
    name: "magaza-otomasyon-sistemleri-175"
  }, {
    path: "/kdv-tevkifati-hesaplama-programi",
    component: _00ef9b12,
    name: "kdv-tevkifati-hesaplama-programi-160"
  }, {
    path: "/ithalat-programi",
    component: _00ef9b12,
    name: "ithalat-programi-203"
  }, {
    path: "/market-stok-programi",
    component: _00ef9b12,
    name: "market-stok-programi-55"
  }, {
    path: "/isci-ikramiye-hesaplama-programi",
    component: _00ef9b12,
    name: "isci-ikramiye-hesaplama-programi-19"
  }, {
    path: "/kasa-defteri-programi",
    component: _00ef9b12,
    name: "kasa-defteri-programi-178"
  }, {
    path: "/imalat-takip-programi",
    component: _00ef9b12,
    name: "imalat-takip-programi-268"
  }, {
    path: "/malzeme-stok-programi",
    component: _00ef9b12,
    name: "malzeme-stok-programi-353"
  }, {
    path: "/kira-damga-vergisi-hesaplama-programi",
    component: _00ef9b12,
    name: "kira-damga-vergisi-hesaplama-programi-428"
  }, {
    path: "/isci-maas-programi",
    component: _00ef9b12,
    name: "isci-maas-programi-310"
  }, {
    path: "/muhasebe-stok-programi",
    component: _00ef9b12,
    name: "muhasebe-stok-programi-111"
  }, {
    path: "/personel-devam-kontrol-programi",
    component: _00ef9b12,
    name: "personel-devam-kontrol-programi-358"
  }, {
    path: "/e-fatura",
    component: _00ef9b12,
    name: "e-fatura-302"
  }, {
    path: "/dis-ticaret-yonetimi-programlari",
    component: _00ef9b12,
    name: "dis-ticaret-yonetimi-programlari-448"
  }, {
    path: "/barkod-otomasyon-sistemi",
    component: _00ef9b12,
    name: "barkod-otomasyon-sistemi-223"
  }, {
    path: "/bordro-hesaplama-programi",
    component: _00ef9b12,
    name: "bordro-hesaplama-programi-381"
  }, {
    path: "/barkodlu-stok-takip-programi",
    component: _00ef9b12,
    name: "barkodlu-stok-takip-programi-135"
  }, {
    path: "/dershane-muhasebe-programi",
    component: _00ef9b12,
    name: "dershane-muhasebe-programi-486"
  }, {
    path: "/barkod-olusturma-programi",
    component: _00ef9b12,
    name: "barkod-olusturma-programi-140"
  }, {
    path: "/fazla-mesai-ucreti-hesaplama",
    component: _00ef9b12,
    name: "fazla-mesai-ucreti-hesaplama-110"
  }, {
    path: "/gunluk-satis-programi",
    component: _00ef9b12,
    name: "gunluk-satis-programi-125"
  }, {
    path: "/hesap-defteri-programi",
    component: _00ef9b12,
    name: "hesap-defteri-programi-314"
  }, {
    path: "/envanter-takip-programi",
    component: _00ef9b12,
    name: "envanter-takip-programi-123"
  }, {
    path: "/fatura-takip-programi",
    component: _00ef9b12,
    name: "fatura-takip-programi-126"
  }, {
    path: "/ik-programi",
    component: _00ef9b12,
    name: "ik-programi-179"
  }, {
    path: "/barkod-okuma-programi",
    component: _00ef9b12,
    name: "barkod-okuma-programi-305"
  }, {
    path: "/demirbas-takip-programi",
    component: _00ef9b12,
    name: "demirbas-takip-programi-429"
  }, {
    path: "/barkod-sistemi-programi",
    component: _00ef9b12,
    name: "barkod-sistemi-programi-117"
  }, {
    path: "/fiyat-listesi-hazirlama-programi",
    component: _00ef9b12,
    name: "fiyat-listesi-hazirlama-programi-319"
  }, {
    path: "/butce-planlama-programi",
    component: _00ef9b12,
    name: "butce-planlama-programi-39"
  }, {
    path: "/e-defter",
    component: _00ef9b12,
    name: "e-defter-114"
  }, {
    path: "/butce-yonetimi-programi",
    component: _00ef9b12,
    name: "butce-yonetimi-programi-201"
  }, {
    path: "/barkodlu-satis-programi",
    component: _00ef9b12,
    name: "barkodlu-satis-programi-93"
  }, {
    path: "/bakkal-satis-programi",
    component: _00ef9b12,
    name: "bakkal-satis-programi-176"
  }, {
    path: "/barkod-yazdirma-programi",
    component: _00ef9b12,
    name: "barkod-yazdirma-programi-353"
  }, {
    path: "/bilgi-islem-envanter-takip-programi",
    component: _00ef9b12,
    name: "bilgi-islem-envanter-takip-programi-330"
  }, {
    path: "/depo-yonetimi-programi",
    component: _00ef9b12,
    name: "depo-yonetimi-programi-379"
  }, {
    path: "/bordro-programi",
    component: _00ef9b12,
    name: "bordro-programi-70"
  }, {
    path: "/e-mustahsil-makbuzu",
    component: _00ef9b12,
    name: "e-mustahsil-makbuzu-249"
  }, {
    path: "/gida-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "gida-sektoru-icin-muhasebe-cozumleri-162"
  }, {
    path: "/perakende-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "perakende-sektoru-icin-muhasebe-cozumleri-50"
  }, {
    path: "/kimya-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "kimya-sektoru-icin-muhasebe-cozumleri-225"
  }, {
    path: "/yapi-malzemeleri-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "yapi-malzemeleri-sektoru-icin-muhasebe-cozumleri-392"
  }, {
    path: "/mikro-asistan-guncelleme",
    component: _00ef9b12,
    name: "mikro-asistan-guncelleme-455"
  }, {
    path: "/tekstil-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "tekstil-sektoru-icin-muhasebe-cozumleri-333"
  }, {
    path: "/insaat-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "insaat-sektoru-icin-muhasebe-cozumleri-484"
  }, {
    path: "/e-irsaliye",
    component: _00ef9b12,
    name: "e-irsaliye-145"
  }, {
    path: "/mikro-fly",
    component: _00ef9b12,
    name: "mikro-fly-265"
  }, {
    path: "/kirtasiye-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "kirtasiye-sektoru-icin-muhasebe-cozumleri-439"
  }, {
    path: "/e-donusum",
    component: _00ef9b12,
    name: "e-donusum-449"
  }, {
    path: "/mobilya-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "mobilya-sektoru-icin-muhasebe-cozumleri-445"
  }, {
    path: "/kontor-fiyatlari",
    component: _00ef9b12,
    name: "kontor-fiyatlari-21"
  }, {
    path: "/e-bordro",
    component: _00ef9b12,
    name: "e-bordro-65"
  }, {
    path: "/mikro-jump",
    component: _00ef9b12,
    name: "mikro-jump-141"
  }, {
    path: "/e-zraporu",
    component: _00ef9b12,
    name: "e-zraporu-237"
  }, {
    path: "/mikro-asistan-destek",
    component: _00ef9b12,
    name: "mikro-asistan-destek-492"
  }, {
    path: "/mikro-musavir",
    component: _00ef9b12,
    name: "mikro-musavir-21"
  }, {
    path: "/perakende-takibi",
    component: _00ef9b12,
    name: "perakende-takibi-176"
  }, {
    path: "/stok-takibi",
    component: _00ef9b12,
    name: "stok-takibi-443"
  }, {
    path: "/otomotiv-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "otomotiv-sektoru-icin-muhasebe-cozumleri-12"
  }, {
    path: "/e-arsiv",
    component: _00ef9b12,
    name: "e-arsiv-61"
  }, {
    path: "/metal-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "metal-sektoru-icin-muhasebe-cozumleri-313"
  }, {
    path: "/e-mutabakat",
    component: _00ef9b12,
    name: "e-mutabakat-236"
  }, {
    path: "/lojistik-sektoru-icin-muhasebe-cozumleri",
    component: _00ef9b12,
    name: "lojistik-sektoru-icin-muhasebe-cozumleri-438"
  }, {
    path: "/uretim-takibi",
    component: _00ef9b12,
    name: "uretim-takibi-493"
  }, {
    path: "/cek-takip-programi",
    component: _00ef9b12,
    name: "cek-takip-programi-496"
  }, {
    path: "/e-beyanname-programi",
    component: _00ef9b12,
    name: "e-beyanname-programi-273"
  }, {
    path: "/cari-hesap-programi",
    component: _00ef9b12,
    name: "cari-hesap-programi-72"
  }, {
    path: "/depo-takip-programi",
    component: _00ef9b12,
    name: "depo-takip-programi-47"
  }, {
    path: "/raporlama",
    component: _00ef9b12,
    name: "raporlama-85"
  }, {
    path: "/anahtar-teslim-e-fatura",
    component: _00ef9b12,
    name: "anahtar-teslim-e-fatura-23"
  }, {
    path: "/e-serbest-meslek-makbuzu",
    component: _00ef9b12,
    name: "e-serbest-meslek-makbuzu-169"
  }, {
    path: "/mikro-hizli-satis-plus-1-40-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-40-hakkinda-390"
  }, {
    path: "/2023-yilinin-enleri-belli-oldu",
    component: _d218fbec,
    name: "2023-yilinin-enleri-belli-oldu-380"
  }, {
    path: "/mikro-hizli-satis-1-43-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-43-hakkinda-493"
  }, {
    path: "/mikro-hizli-satis-1-40-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-40-hakkinda-100"
  }, {
    path: "/mikro-hizli-satis-plus-1-41-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-41-hakkinda-302"
  }, {
    path: "/mikro-hizli-satis-1-42-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-42-hakkinda-314"
  }, {
    path: "/mikro-hizli-satis-plus-1-43-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-43-hakkinda-151"
  }, {
    path: "/mikro-hizli-satis-1-41-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-41-hakkinda-345"
  }, {
    path: "/mikro-hizli-satis-plus-1-29-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-29-hakkinda-261"
  }, {
    path: "/mikro-hizli-satis-plus-1-42-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-42-hakkinda-227"
  }, {
    path: "/mikro-hizli-satis-1-39-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-39-hakkinda-434"
  }, {
    path: "/mikro-hizli-satis-1-26-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-26-hakkinda-125"
  }, {
    path: "/mikro-hizli-satis-1-33-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-33-hakkinda-278"
  }, {
    path: "/mikro-hizli-satis-1-38-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-38-hakkinda-18"
  }, {
    path: "/mikro-hizli-satis-plus-1-39-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-39-hakkinda-175"
  }, {
    path: "/mikro-hizli-satis-plus-1-36-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-36-hakkinda-98"
  }, {
    path: "/mikro-hizli-satis-1-34-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-34-hakkinda-499"
  }, {
    path: "/mikro-hizli-satis-plus-1-38-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-38-hakkinda-284"
  }, {
    path: "/mikro-hizli-satis-1-37-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-37-hakkinda-451"
  }, {
    path: "/mikro-hizli-satis-plus-1-33-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-33-hakkinda-382"
  }, {
    path: "/mikro-hizli-satis-plus-1-34-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-34-hakkinda-325"
  }, {
    path: "/mikro-hizli-satis-1-36-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-36-hakkinda-334"
  }, {
    path: "/mikro-hizli-satis-plus-1-37-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-37-hakkinda-442"
  }, {
    path: "/mikro-hizli-satis-1-27-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-27-hakkinda-197"
  }, {
    path: "/mikro-hizli-satis-plus-1-28-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-28-hakkinda-264"
  }, {
    path: "/mikro-hizli-satis-1-28-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-28-hakkinda-423"
  }, {
    path: "/mikro-hizli-satis-plus-1-27-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-27-hakkinda-145"
  }, {
    path: "/mikro-hizli-satis-plus-1-30-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-30-hakkinda-104"
  }, {
    path: "/mikro-hizli-satis-1-32-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-32-hakkinda-245"
  }, {
    path: "/mikro-hizli-satis-plus-1-31-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-31-hakkinda-241"
  }, {
    path: "/mikro-hizli-satis-1-31-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-31-hakkinda-301"
  }, {
    path: "/mikro-hizli-satis-1-30-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-30-hakkinda-285"
  }, {
    path: "/mikro-hizli-satis-plus-1-26-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-26-hakkinda-382"
  }, {
    path: "/mikro-hizli-satis-1-29-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-1-29-hakkinda-272"
  }, {
    path: "/mikro-hizli-satis-plus-1-32-hakkinda",
    component: _d218fbec,
    name: "mikro-hizli-satis-plus-1-32-hakkinda-153"
  }, {
    path: "/tam-mukellef-nedir",
    component: _43bf8176,
    name: "tam-mukellef-nedir-462"
  }, {
    path: "/icra-nedir",
    component: _43bf8176,
    name: "icra-nedir-86"
  }, {
    path: "/finansal-okuryazarlik-terimleri-nelerdir",
    component: _43bf8176,
    name: "finansal-okuryazarlik-terimleri-nelerdir-246"
  }, {
    path: "/656-hesap-nedir",
    component: _43bf8176,
    name: "656-hesap-nedir-294"
  }, {
    path: "/arzuhalci-ne-demektir",
    component: _43bf8176,
    name: "arzuhalci-ne-demektir-495"
  }, {
    path: "/muhtasar-odeme-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "muhtasar-odeme-muhasebe-kaydi-nasil-yapilir-454"
  }, {
    path: "/nakit-oran-formulu-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "nakit-oran-formulu-nedir-nasil-hesaplanir-116"
  }, {
    path: "/tek-duzen-hesap-plani-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "tek-duzen-hesap-plani-nedir-nasil-yapilir-195"
  }, {
    path: "/131-hesap-nedir",
    component: _43bf8176,
    name: "131-hesap-nedir-193"
  }, {
    path: "/646-hesap-nedir",
    component: _43bf8176,
    name: "646-hesap-nedir-29"
  }, {
    path: "/336-hesap-nedir",
    component: _43bf8176,
    name: "336-hesap-nedir-352"
  }, {
    path: "/surekli-ve-aralikli-envanter-yontemi",
    component: _43bf8176,
    name: "surekli-ve-aralikli-envanter-yontemi-133"
  }, {
    path: "/740-hesap-nedir",
    component: _43bf8176,
    name: "740-hesap-nedir-19"
  }, {
    path: "/guven-damgasi-nedir",
    component: _43bf8176,
    name: "guven-damgasi-nedir-9"
  }, {
    path: "/381-hesap-nedir",
    component: _43bf8176,
    name: "381-hesap-nedir-99"
  }, {
    path: "/nft-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "nft-nedir-nasil-yapilir-159"
  }, {
    path: "/e-fatura-entegrator-degisikligi",
    component: _43bf8176,
    name: "e-fatura-entegrator-degisikligi-3"
  }, {
    path: "/saas-nedir",
    component: _43bf8176,
    name: "saas-nedir-294"
  }, {
    path: "/gider-pusulasi-nedir-ne-zaman-kullanilir",
    component: _43bf8176,
    name: "gider-pusulasi-nedir-ne-zaman-kullanilir-460"
  }, {
    path: "/ogrenci-takip-programi-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "ogrenci-takip-programi-nedir-ne-ise-yarar-490"
  }, {
    path: "/kur-farki-faturasi-nedir",
    component: _43bf8176,
    name: "kur-farki-faturasi-nedir-80"
  }, {
    path: "/youtube-gelirlerinin-vergilendirilmesi",
    component: _43bf8176,
    name: "youtube-gelirlerinin-vergilendirilmesi-22"
  }, {
    path: "/devlet-memuru-sahis-sirketi-kurabilir-mi",
    component: _43bf8176,
    name: "devlet-memuru-sahis-sirketi-kurabilir-mi-52"
  }, {
    path: "/karadagda-sirket-kurmak-avantajlari-nelerdir-nasil-kurulur",
    component: _43bf8176,
    name: "karadagda-sirket-kurmak-avantajlari-nelerdir-nasil-kurulur-10"
  }, {
    path: "/e-ticaret-muhasebesi-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "e-ticaret-muhasebesi-nedir-nasil-yapilir-277"
  }, {
    path: "/fatura-cesitleri-nelerdir",
    component: _43bf8176,
    name: "fatura-cesitleri-nelerdir-158"
  }, {
    path: "/tarh-nedir-verginin-tarhi-nasil-olur",
    component: _43bf8176,
    name: "tarh-nedir-verginin-tarhi-nasil-olur-184"
  }, {
    path: "/sanal-ofis-nedir",
    component: _43bf8176,
    name: "sanal-ofis-nedir-456"
  }, {
    path: "/basit-usul-nedir-ve-basit-usulde-vergi-mukellefi-kimdir",
    component: _43bf8176,
    name: "basit-usul-nedir-ve-basit-usulde-vergi-mukellefi-kimdir-480"
  }, {
    path: "/e-yoklama-fisi-nedir-ve-ne-ise-yarar",
    component: _43bf8176,
    name: "e-yoklama-fisi-nedir-ve-ne-ise-yarar-17"
  }, {
    path: "/genc-girisimci-vergi-muafiyeti-nedir-kimler-icin-gecerlidir",
    component: _43bf8176,
    name: "genc-girisimci-vergi-muafiyeti-nedir-kimler-icin-gecerlidir-228"
  }, {
    path: "/gecici-vergi-muhasebe-kaydi-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "gecici-vergi-muhasebe-kaydi-nedir-nasil-yapilir-345"
  }, {
    path: "/is-cikis-kodlari-nelerdir",
    component: _43bf8176,
    name: "is-cikis-kodlari-nelerdir-309"
  }, {
    path: "/navlun-faturasi-nedir",
    component: _43bf8176,
    name: "navlun-faturasi-nedir-220"
  }, {
    path: "/mahsup-fisi-nedir-mahsup-fisi-nasil-duzenlenir",
    component: _43bf8176,
    name: "mahsup-fisi-nedir-mahsup-fisi-nasil-duzenlenir-276"
  }, {
    path: "/imza-beyani-ve-imza-sirkusu-nedir-nasil-alinir",
    component: _43bf8176,
    name: "imza-beyani-ve-imza-sirkusu-nedir-nasil-alinir-181"
  }, {
    path: "/genel-muhasebe-nedir",
    component: _43bf8176,
    name: "genel-muhasebe-nedir-464"
  }, {
    path: "/gider-pusulasinda-stopaj-oranlari-nedir-gider-pusulasi-stopaj-hesaplama-nasil-yapilir",
    component: _43bf8176,
    name: "gider-pusulasinda-stopaj-oranlari-nedir-gider-pusulasi-stopaj-hesaplama-nasil-yapilir-373"
  }, {
    path: "/gcb-sorgulama-nasil-yapilir",
    component: _43bf8176,
    name: "gcb-sorgulama-nasil-yapilir-477"
  }, {
    path: "/320-hesap-nedir",
    component: _43bf8176,
    name: "320-hesap-nedir-296"
  }, {
    path: "/649-hesap-nedir",
    component: _43bf8176,
    name: "649-hesap-nedir-419"
  }, {
    path: "/sozlesme-damga-vergisi-nedir",
    component: _43bf8176,
    name: "sozlesme-damga-vergisi-nedir-219"
  }, {
    path: "/e-belge-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "e-belge-nedir-ne-ise-yarar-264"
  }, {
    path: "/olcek-ekonomisi-nedir",
    component: _43bf8176,
    name: "olcek-ekonomisi-nedir-243"
  }, {
    path: "/roas-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "roas-nedir-nasil-hesaplanir-74"
  }, {
    path: "/nps-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "nps-nedir-nasil-hesaplanir-468"
  }, {
    path: "/yunanistanda-sirket-kurmak-avantajlari-nedir-nasil-kurulur",
    component: _43bf8176,
    name: "yunanistanda-sirket-kurmak-avantajlari-nedir-nasil-kurulur-88"
  }, {
    path: "/proaktif-yaklasim-nedir",
    component: _43bf8176,
    name: "proaktif-yaklasim-nedir-33"
  }, {
    path: "/e-ticaret-vergileri-hangileridir",
    component: _43bf8176,
    name: "e-ticaret-vergileri-hangileridir-180"
  }, {
    path: "/mobil-imza-nedir-nasil-alinir",
    component: _43bf8176,
    name: "mobil-imza-nedir-nasil-alinir-402"
  }, {
    path: "/muhtasar-beyanname-kodlari-nelerdir",
    component: _43bf8176,
    name: "muhtasar-beyanname-kodlari-nelerdir-496"
  }, {
    path: "/forfaiting-nedir",
    component: _43bf8176,
    name: "forfaiting-nedir-111"
  }, {
    path: "/bayilik-nedir",
    component: _43bf8176,
    name: "bayilik-nedir-370"
  }, {
    path: "/mersis-no-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "mersis-no-nedir-ne-ise-yarar-177"
  }, {
    path: "/faiz-artirimi-nedir-faiz-artirimi-etkileri-nelerdir",
    component: _43bf8176,
    name: "faiz-artirimi-nedir-faiz-artirimi-etkileri-nelerdir-209"
  }, {
    path: "/e-retailing-e-perakendecilik-nedir",
    component: _43bf8176,
    name: "e-retailing-e-perakendecilik-nedir-161"
  }, {
    path: "/geriye-donuk-fatura-kesilir-mi",
    component: _43bf8176,
    name: "geriye-donuk-fatura-kesilir-mi-444"
  }, {
    path: "/bedelli-sermaye-artirimi-nedir",
    component: _43bf8176,
    name: "bedelli-sermaye-artirimi-nedir-165"
  }, {
    path: "/nakliye-faturalarinda-tevkifat",
    component: _43bf8176,
    name: "nakliye-faturalarinda-tevkifat-460"
  }, {
    path: "/e-ihracat-nedir-firsat-ve-avantajlari-nelerdir",
    component: _43bf8176,
    name: "e-ihracat-nedir-firsat-ve-avantajlari-nelerdir-490"
  }, {
    path: "/fizibilite-calismasi-nasil-yapilir",
    component: _43bf8176,
    name: "fizibilite-calismasi-nasil-yapilir-304"
  }, {
    path: "/e-defter-saklama-nedir",
    component: _43bf8176,
    name: "e-defter-saklama-nedir-140"
  }, {
    path: "/cari-mutabakat-nedir-nasil-saglanir",
    component: _43bf8176,
    name: "cari-mutabakat-nedir-nasil-saglanir-32"
  }, {
    path: "/e-defter-kapanis-tasdiki-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "e-defter-kapanis-tasdiki-nedir-nasil-yapilir-65"
  }, {
    path: "/kooperatif-sirket-nedir",
    component: _43bf8176,
    name: "kooperatif-sirket-nedir-216"
  }, {
    path: "/sirket-nasil-kapatilir-tasfiyeli-ve-tasfiyesiz-sirket-kapatmak",
    component: _43bf8176,
    name: "sirket-nasil-kapatilir-tasfiyeli-ve-tasfiyesiz-sirket-kapatmak-315"
  }, {
    path: "/e-ticaret-entegrasyonu-nedir",
    component: _43bf8176,
    name: "e-ticaret-entegrasyonu-nedir-350"
  }, {
    path: "/vergi-gecikme-cezasi-nedir",
    component: _43bf8176,
    name: "vergi-gecikme-cezasi-nedir-112"
  }, {
    path: "/e-defter-beratlari-nasil-goruntulenir",
    component: _43bf8176,
    name: "e-defter-beratlari-nasil-goruntulenir-499"
  }, {
    path: "/sirketlerde-ortakliktan-cikma-ya-da-cikarma-nasil-olur",
    component: _43bf8176,
    name: "sirketlerde-ortakliktan-cikma-ya-da-cikarma-nasil-olur-102"
  }, {
    path: "/nakit-akisi-nedir-nasil-yonetilir",
    component: _43bf8176,
    name: "nakit-akisi-nedir-nasil-yonetilir-467"
  }, {
    path: "/sirket-sermayesi-hakkinda-bilinmesi-gerekenler",
    component: _43bf8176,
    name: "sirket-sermayesi-hakkinda-bilinmesi-gerekenler-432"
  }, {
    path: "/zirai-kazanc-nedir-zirai-kazancin-vergilendirilmesi-nasil-yapilir",
    component: _43bf8176,
    name: "zirai-kazanc-nedir-zirai-kazancin-vergilendirilmesi-nasil-yapilir-72"
  }, {
    path: "/sgk-aylik-bildirge-nedir-bu-bildirim-nasil-yapilir",
    component: _43bf8176,
    name: "sgk-aylik-bildirge-nedir-bu-bildirim-nasil-yapilir-36"
  }, {
    path: "/muhtasar-beyanname-nedir",
    component: _43bf8176,
    name: "muhtasar-beyanname-nedir-52"
  }, {
    path: "/e-fatura-iptali-ve-e-fatura-iadesi-nasil-yapilir",
    component: _43bf8176,
    name: "e-fatura-iptali-ve-e-fatura-iadesi-nasil-yapilir-453"
  }, {
    path: "/hangi-durumlarda-kira-vergisi-odenmez",
    component: _43bf8176,
    name: "hangi-durumlarda-kira-vergisi-odenmez-300"
  }, {
    path: "/finansal-tablolar-nasil-hazirlanir-ve-nasil-ongorude-bulunulur",
    component: _43bf8176,
    name: "finansal-tablolar-nasil-hazirlanir-ve-nasil-ongorude-bulunulur-156"
  }, {
    path: "/e-defteri-gec-gondermenin-cezasi-nedir",
    component: _43bf8176,
    name: "e-defteri-gec-gondermenin-cezasi-nedir-227"
  }, {
    path: "/defter-hadleri-nelerdir",
    component: _43bf8176,
    name: "defter-hadleri-nelerdir-226"
  }, {
    path: "/e-arsiv-fatura-siniri",
    component: _43bf8176,
    name: "e-arsiv-fatura-siniri-194"
  }, {
    path: "/kanunen-kabul-edilmeyen-giderler-kkeg-nelerdir",
    component: _43bf8176,
    name: "kanunen-kabul-edilmeyen-giderler-kkeg-nelerdir-24"
  }, {
    path: "/tum-kanuni-boyutlari-ve-detaylariyla-cek",
    component: _43bf8176,
    name: "tum-kanuni-boyutlari-ve-detaylariyla-cek-321"
  }, {
    path: "/avukat-serbest-meslek-makbuzu-nasil-kesilir",
    component: _43bf8176,
    name: "avukat-serbest-meslek-makbuzu-nasil-kesilir-436"
  }, {
    path: "/e-defter-basvurusu-nasil-yapilir",
    component: _43bf8176,
    name: "e-defter-basvurusu-nasil-yapilir-239"
  }, {
    path: "/muhasebede-donemsellik-kavrami-nedir",
    component: _43bf8176,
    name: "muhasebede-donemsellik-kavrami-nedir-137"
  }, {
    path: "/google-ad-sense-nedir",
    component: _43bf8176,
    name: "google-ad-sense-nedir-307"
  }, {
    path: "/770-hesap",
    component: _43bf8176,
    name: "770-hesap-196"
  }, {
    path: "/limited-ve-anonim-sirketlerde-adres-degisikligi-nasil-yapilir",
    component: _43bf8176,
    name: "limited-ve-anonim-sirketlerde-adres-degisikligi-nasil-yapilir-44"
  }, {
    path: "/127-hesap",
    component: _43bf8176,
    name: "127-hesap-378"
  }, {
    path: "/uretim-yonetimi-nedir-isletmelere-sagladigi-faydalar-nelerdir",
    component: _43bf8176,
    name: "uretim-yonetimi-nedir-isletmelere-sagladigi-faydalar-nelerdir-244"
  }, {
    path: "/gelir-tablosu-nasil-hazirlanir",
    component: _43bf8176,
    name: "gelir-tablosu-nasil-hazirlanir-64"
  }, {
    path: "/195-hesap-nedir",
    component: _43bf8176,
    name: "195-hesap-nedir-360"
  }, {
    path: "/e-arsiv-faturada-imza-zorunlulugu",
    component: _43bf8176,
    name: "e-arsiv-faturada-imza-zorunlulugu-88"
  }, {
    path: "/760-hesap",
    component: _43bf8176,
    name: "760-hesap-487"
  }, {
    path: "/bloke-cek-nedir",
    component: _43bf8176,
    name: "bloke-cek-nedir-438"
  }, {
    path: "/329-hesap-nedir",
    component: _43bf8176,
    name: "329-hesap-nedir-269"
  }, {
    path: "/kapali-fatura-nedir",
    component: _43bf8176,
    name: "kapali-fatura-nedir-279"
  }, {
    path: "/108-hesap",
    component: _43bf8176,
    name: "108-hesap-178"
  }, {
    path: "/cek-defteri-cek-karnesi-alma-sartlari-nelerdir",
    component: _43bf8176,
    name: "cek-defteri-cek-karnesi-alma-sartlari-nelerdir-303"
  }, {
    path: "/anonim-sirket-avantajlari",
    component: _43bf8176,
    name: "anonim-sirket-avantajlari-159"
  }, {
    path: "/kefalet-sozlesmesi-nedir",
    component: _43bf8176,
    name: "kefalet-sozlesmesi-nedir-484"
  }, {
    path: "/ikale-sozlesmesi-nedir",
    component: _43bf8176,
    name: "ikale-sozlesmesi-nedir-432"
  }, {
    path: "/e-arsiv-fatura-duzeltme",
    component: _43bf8176,
    name: "e-arsiv-fatura-duzeltme-238"
  }, {
    path: "/e-fatura-durum-kodlari",
    component: _43bf8176,
    name: "e-fatura-durum-kodlari-42"
  }, {
    path: "/limited-sirket-avantajlari",
    component: _43bf8176,
    name: "limited-sirket-avantajlari-223"
  }, {
    path: "/kidem-tazminati-nasil-hesaplanir",
    component: _43bf8176,
    name: "kidem-tazminati-nasil-hesaplanir-446"
  }, {
    path: "/faaliyet-kari-nedir",
    component: _43bf8176,
    name: "faaliyet-kari-nedir-288"
  }, {
    path: "/dijital-muhasebe-nedir",
    component: _43bf8176,
    name: "dijital-muhasebe-nedir-17"
  }, {
    path: "/sirket-vergi-borcu-nasil-sorgulanir",
    component: _43bf8176,
    name: "sirket-vergi-borcu-nasil-sorgulanir-428"
  }, {
    path: "/deneyimsel-pazarlama-nedir",
    component: _43bf8176,
    name: "deneyimsel-pazarlama-nedir-323"
  }, {
    path: "/kosgeb-genc-kadin-girisimci-destekleri",
    component: _43bf8176,
    name: "kosgeb-genc-kadin-girisimci-destekleri-436"
  }, {
    path: "/vergi-takvimi",
    component: _43bf8176,
    name: "vergi-takvimi-319"
  }, {
    path: "/kdvden-matrah-hesaplama",
    component: _43bf8176,
    name: "kdvden-matrah-hesaplama-268"
  }, {
    path: "/e-arsiv-ile-e-fatura-arasindaki-farklar-nelerdir",
    component: _43bf8176,
    name: "e-arsiv-ile-e-fatura-arasindaki-farklar-nelerdir-449"
  }, {
    path: "/371-hesap-nedir",
    component: _43bf8176,
    name: "371-hesap-nedir-174"
  }, {
    path: "/dolaysiz-vergi-nedir",
    component: _43bf8176,
    name: "dolaysiz-vergi-nedir-376"
  }, {
    path: "/267-hesap",
    component: _43bf8176,
    name: "267-hesap-410"
  }, {
    path: "/damga-vergisi-oran-ve-tutarlari",
    component: _43bf8176,
    name: "damga-vergisi-oran-ve-tutarlari-376"
  }, {
    path: "/mali-muhur-nedir-mali-muhur-basvurusu-nasil-yapilir",
    component: _43bf8176,
    name: "mali-muhur-nedir-mali-muhur-basvurusu-nasil-yapilir-441"
  }, {
    path: "/kimler-e-tebligat-basvurusu-yapmali",
    component: _43bf8176,
    name: "kimler-e-tebligat-basvurusu-yapmali-385"
  }, {
    path: "/vergi-odemeleri-hangileridir-ne-zaman-odenir",
    component: _43bf8176,
    name: "vergi-odemeleri-hangileridir-ne-zaman-odenir-69"
  }, {
    path: "/finans-ve-muhasebe-farki",
    component: _43bf8176,
    name: "finans-ve-muhasebe-farki-74"
  }, {
    path: "/642-hesap",
    component: _43bf8176,
    name: "642-hesap-475"
  }, {
    path: "/e-ticaret-nedir-bilmeniz-gerekenler-nelerdir",
    component: _43bf8176,
    name: "e-ticaret-nedir-bilmeniz-gerekenler-nelerdir-348"
  }, {
    path: "/e-arsiv-faturaya-nasil-gecilir-e-arsiv-faturaya-gecme-sartlari-nelerdir",
    component: _43bf8176,
    name: "e-arsiv-faturaya-nasil-gecilir-e-arsiv-faturaya-gecme-sartlari-nelerdir-50"
  }, {
    path: "/e-fatura-mukellefine-e-arsiv-faturasi-kesilir-mi",
    component: _43bf8176,
    name: "e-fatura-mukellefine-e-arsiv-faturasi-kesilir-mi-263"
  }, {
    path: "/260-hesap",
    component: _43bf8176,
    name: "260-hesap-16"
  }, {
    path: "/679-hesap-nedir",
    component: _43bf8176,
    name: "679-hesap-nedir-86"
  }, {
    path: "/e-fatura-saklama-zorunlulugu",
    component: _43bf8176,
    name: "e-fatura-saklama-zorunlulugu-187"
  }, {
    path: "/muhtasar-ve-prim-hizmet-beyannamesi-muhsgk-uygulanmaya-basliyor",
    component: _43bf8176,
    name: "muhtasar-ve-prim-hizmet-beyannamesi-muhsgk-uygulanmaya-basliyor-432"
  }, {
    path: "/hazirun-cetveli-nedir",
    component: _43bf8176,
    name: "hazirun-cetveli-nedir-198"
  }, {
    path: "/380-hesap-nedir",
    component: _43bf8176,
    name: "380-hesap-nedir-457"
  }, {
    path: "/vergi-matrahi",
    component: _43bf8176,
    name: "vergi-matrahi-448"
  }, {
    path: "/kdv-matrah-artirimi-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "kdv-matrah-artirimi-muhasebe-kaydi-nasil-yapilir-17"
  }, {
    path: "/730-hesap-nedir",
    component: _43bf8176,
    name: "730-hesap-nedir-48"
  }, {
    path: "/yurt-disi-e-ticaret-operasyonlarinda-devlet-destekleri",
    component: _43bf8176,
    name: "yurt-disi-e-ticaret-operasyonlarinda-devlet-destekleri-362"
  }, {
    path: "/otvli-fatura-muhasebe-kaydi-otvli-fatura-nasil-kesilir",
    component: _43bf8176,
    name: "otvli-fatura-muhasebe-kaydi-otvli-fatura-nasil-kesilir-444"
  }, {
    path: "/sirket-nasil-kurulur-adim-adim-sirket-kurma-rehberi",
    component: _43bf8176,
    name: "sirket-nasil-kurulur-adim-adim-sirket-kurma-rehberi-2"
  }, {
    path: "/issizlik-maasi-nedir",
    component: _43bf8176,
    name: "issizlik-maasi-nedir-279"
  }, {
    path: "/370-hesap-nedir",
    component: _43bf8176,
    name: "370-hesap-nedir-122"
  }, {
    path: "/vergi-ziyai-nedir",
    component: _43bf8176,
    name: "vergi-ziyai-nedir-64"
  }, {
    path: "/kisa-calisma-odenegi-kco-nedir",
    component: _43bf8176,
    name: "kisa-calisma-odenegi-kco-nedir-151"
  }, {
    path: "/150-hesap",
    component: _43bf8176,
    name: "150-hesap-469"
  }, {
    path: "/181-hesap-nedir",
    component: _43bf8176,
    name: "181-hesap-nedir-210"
  }, {
    path: "/serbest-meslek-nedir",
    component: _43bf8176,
    name: "serbest-meslek-nedir-273"
  }, {
    path: "/internet-uzerinden-satis-yapanlarda-e-fatura-zorunlulugu-nedir",
    component: _43bf8176,
    name: "internet-uzerinden-satis-yapanlarda-e-fatura-zorunlulugu-nedir-465"
  }, {
    path: "/e-fatura-dizayni-nasil-yapilir",
    component: _43bf8176,
    name: "e-fatura-dizayni-nasil-yapilir-100"
  }, {
    path: "/kurumlar-vergisi-nasil-hesaplanir",
    component: _43bf8176,
    name: "kurumlar-vergisi-nasil-hesaplanir-117"
  }, {
    path: "/neden-mikro-fly-kullanmalisiniz",
    component: _43bf8176,
    name: "neden-mikro-fly-kullanmalisiniz-229"
  }, {
    path: "/on-fizibilite-nedir",
    component: _43bf8176,
    name: "on-fizibilite-nedir-50"
  }, {
    path: "/309-hesap",
    component: _43bf8176,
    name: "309-hesap-32"
  }, {
    path: "/avukat-gelir-vergisi-nasil-hesaplanir",
    component: _43bf8176,
    name: "avukat-gelir-vergisi-nasil-hesaplanir-179"
  }, {
    path: "/321-borc-senetleri",
    component: _43bf8176,
    name: "321-borc-senetleri-139"
  }, {
    path: "/590-hesap-nedir",
    component: _43bf8176,
    name: "590-hesap-nedir-290"
  }, {
    path: "/bedelsiz-ihracat-nedir",
    component: _43bf8176,
    name: "bedelsiz-ihracat-nedir-395"
  }, {
    path: "/mali-muhur-yenileme-sureci-ve-islemleri",
    component: _43bf8176,
    name: "mali-muhur-yenileme-sureci-ve-islemleri-52"
  }, {
    path: "/lehtar-nedir",
    component: _43bf8176,
    name: "lehtar-nedir-461"
  }, {
    path: "/dar-mukellef-kime-denir",
    component: _43bf8176,
    name: "dar-mukellef-kime-denir-156"
  }, {
    path: "/senet-nasil-doldurulur",
    component: _43bf8176,
    name: "senet-nasil-doldurulur-240"
  }, {
    path: "/612-hesap",
    component: _43bf8176,
    name: "612-hesap-249"
  }, {
    path: "/is-sozlesmesi-turleri-nelerdir",
    component: _43bf8176,
    name: "is-sozlesmesi-turleri-nelerdir-50"
  }, {
    path: "/icra-davasi-nasil-acilir",
    component: _43bf8176,
    name: "icra-davasi-nasil-acilir-127"
  }, {
    path: "/startup-sirketi-nedir",
    component: _43bf8176,
    name: "startup-sirketi-nedir-368"
  }, {
    path: "/sgk-sahis-odemeleri-nedir",
    component: _43bf8176,
    name: "sgk-sahis-odemeleri-nedir-147"
  }, {
    path: "/e-fatura-mukellefi-kagit-fatura-kesebilir-mi",
    component: _43bf8176,
    name: "e-fatura-mukellefi-kagit-fatura-kesebilir-mi-477"
  }, {
    path: "/e-fatura-gecis-zorunlulugu-ve-sartlari",
    component: _43bf8176,
    name: "e-fatura-gecis-zorunlulugu-ve-sartlari-280"
  }, {
    path: "/gayrinakdi-kredi-nedir",
    component: _43bf8176,
    name: "gayrinakdi-kredi-nedir-472"
  }, {
    path: "/stoksuz-e-ticaret-dropshipping-nedir",
    component: _43bf8176,
    name: "stoksuz-e-ticaret-dropshipping-nedir-436"
  }, {
    path: "/hamiline-cek-nedir",
    component: _43bf8176,
    name: "hamiline-cek-nedir-303"
  }, {
    path: "/gayrimenkul-sermaye-iradi-ve-istisnasi-nedir",
    component: _43bf8176,
    name: "gayrimenkul-sermaye-iradi-ve-istisnasi-nedir-448"
  }, {
    path: "/hamiline-yazili-anonim-sirket-pay-senetleri-ne-sekilde-devredilir",
    component: _43bf8176,
    name: "hamiline-yazili-anonim-sirket-pay-senetleri-ne-sekilde-devredilir-245"
  }, {
    path: "/sirket-kurmadan-fatura-kesmek",
    component: _43bf8176,
    name: "sirket-kurmadan-fatura-kesmek-242"
  }, {
    path: "/muteselsil-kefil-kimdir",
    component: _43bf8176,
    name: "muteselsil-kefil-kimdir-11"
  }, {
    path: "/tahakkuk-fisi-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "tahakkuk-fisi-nedir-ne-ise-yarar-188"
  }, {
    path: "/611-hesap",
    component: _43bf8176,
    name: "611-hesap-257"
  }, {
    path: "/matrah-artirimi-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "matrah-artirimi-nedir-nasil-yapilir-236"
  }, {
    path: "/659-hesap",
    component: _43bf8176,
    name: "659-hesap-228"
  }, {
    path: "/b2b-is-modeli-nedir",
    component: _43bf8176,
    name: "b2b-is-modeli-nedir-309"
  }, {
    path: "/193-hesap",
    component: _43bf8176,
    name: "193-hesap-392"
  }, {
    path: "/butce-yonetimi-nedir",
    component: _43bf8176,
    name: "butce-yonetimi-nedir-111"
  }, {
    path: "/depo-yonetimi-nedir",
    component: _43bf8176,
    name: "depo-yonetimi-nedir-339"
  }, {
    path: "/sirket-unvani-nasil-secilir",
    component: _43bf8176,
    name: "sirket-unvani-nasil-secilir-376"
  }, {
    path: "/sahis-sirketinden-limited-sirkete-gecis",
    component: _43bf8176,
    name: "sahis-sirketinden-limited-sirkete-gecis-252"
  }, {
    path: "/stok-yonetimi-nedir-neden-yapilir",
    component: _43bf8176,
    name: "stok-yonetimi-nedir-neden-yapilir-276"
  }, {
    path: "/368-hesap-nedir",
    component: _43bf8176,
    name: "368-hesap-nedir-225"
  }, {
    path: "/envanter-defteri-nedir-nasil-tutulur",
    component: _43bf8176,
    name: "envanter-defteri-nedir-nasil-tutulur-22"
  }, {
    path: "/limited-sirketi-nedir-genel-esas-ve-yukumlulukleri",
    component: _43bf8176,
    name: "limited-sirketi-nedir-genel-esas-ve-yukumlulukleri-281"
  }, {
    path: "/e-ticarette-fiyatlandirma",
    component: _43bf8176,
    name: "e-ticarette-fiyatlandirma-155"
  }, {
    path: "/banka-entegrasyonu",
    component: _43bf8176,
    name: "banka-entegrasyonu-365"
  }, {
    path: "/tahsilat-nedir-e-tahsilat-islemi-nasil-yapilir",
    component: _43bf8176,
    name: "tahsilat-nedir-e-tahsilat-islemi-nasil-yapilir-294"
  }, {
    path: "/cek-vadesi-hesaplama",
    component: _43bf8176,
    name: "cek-vadesi-hesaplama-171"
  }, {
    path: "/fatura-unvani-nedir",
    component: _43bf8176,
    name: "fatura-unvani-nedir-416"
  }, {
    path: "/kosgeb-nedir-kosgeb-destekleri-nelerdir",
    component: _43bf8176,
    name: "kosgeb-nedir-kosgeb-destekleri-nelerdir-166"
  }, {
    path: "/ibraname-nedir",
    component: _43bf8176,
    name: "ibraname-nedir-98"
  }, {
    path: "/691-hesap-nedir",
    component: _43bf8176,
    name: "691-hesap-nedir-89"
  }, {
    path: "/neden-mikro-jump-kullanmalisiniz",
    component: _43bf8176,
    name: "neden-mikro-jump-kullanmalisiniz-456"
  }, {
    path: "/satis-teklifi-nedir-satis-teklifi-nasil-hazirlanir",
    component: _43bf8176,
    name: "satis-teklifi-nedir-satis-teklifi-nasil-hazirlanir-283"
  }, {
    path: "/159-hesap-nedir",
    component: _43bf8176,
    name: "159-hesap-nedir-292"
  }, {
    path: "/yurt-disi-faturalarin-vergilendirilmesi",
    component: _43bf8176,
    name: "yurt-disi-faturalarin-vergilendirilmesi-333"
  }, {
    path: "/proforma-teklif-ornegi",
    component: _43bf8176,
    name: "proforma-teklif-ornegi-359"
  }, {
    path: "/tahsilat-makbuzu-nedir-nasil-kesilir",
    component: _43bf8176,
    name: "tahsilat-makbuzu-nedir-nasil-kesilir-330"
  }, {
    path: "/saglikli-buyuyen-isletmelerin-on-muhasebe-programi-bizmu",
    component: _43bf8176,
    name: "saglikli-buyuyen-isletmelerin-on-muhasebe-programi-bizmu-223"
  }, {
    path: "/e-ticaret-tedarigi-nedir",
    component: _43bf8176,
    name: "e-ticaret-tedarigi-nedir-377"
  }, {
    path: "/331-hesap-nedir",
    component: _43bf8176,
    name: "331-hesap-nedir-375"
  }, {
    path: "/seri-lot-takibi",
    component: _43bf8176,
    name: "seri-lot-takibi-311"
  }, {
    path: "/180-hesap-nedir",
    component: _43bf8176,
    name: "180-hesap-nedir-345"
  }, {
    path: "/gider-pusulasi-muhasebe-kaydi",
    component: _43bf8176,
    name: "gider-pusulasi-muhasebe-kaydi-429"
  }, {
    path: "/cari-hesaplar-nedir",
    component: _43bf8176,
    name: "cari-hesaplar-nedir-88"
  }, {
    path: "/e-fatura-nasil-kesilir",
    component: _43bf8176,
    name: "e-fatura-nasil-kesilir-495"
  }, {
    path: "/tedarik-zinciri-nedir",
    component: _43bf8176,
    name: "tedarik-zinciri-nedir-244"
  }, {
    path: "/mrp-ile-mrp2-arasindaki-farklar-nelerdir",
    component: _43bf8176,
    name: "mrp-ile-mrp2-arasindaki-farklar-nelerdir-148"
  }, {
    path: "/vergi-dairesinde-hangi-islemler-yapilir",
    component: _43bf8176,
    name: "vergi-dairesinde-hangi-islemler-yapilir-92"
  }, {
    path: "/2022-agi-kalkti-mi",
    component: _43bf8176,
    name: "2022-agi-kalkti-mi-262"
  }, {
    path: "/varlik-yonetim-sirketi-nedir",
    component: _43bf8176,
    name: "varlik-yonetim-sirketi-nedir-65"
  }, {
    path: "/fis-ve-fatura-almanin-onemi-nedir",
    component: _43bf8176,
    name: "fis-ve-fatura-almanin-onemi-nedir-247"
  }, {
    path: "/621-hesap",
    component: _43bf8176,
    name: "621-hesap-178"
  }, {
    path: "/ayni-yardim-nedir-vergisel-avantajlari-nelerdir",
    component: _43bf8176,
    name: "ayni-yardim-nedir-vergisel-avantajlari-nelerdir-242"
  }, {
    path: "/muhtasar-vergisi-nedir",
    component: _43bf8176,
    name: "muhtasar-vergisi-nedir-460"
  }, {
    path: "/acik-fatura-nedir-acik-fatura-nasil-kesilir",
    component: _43bf8176,
    name: "acik-fatura-nedir-acik-fatura-nasil-kesilir-321"
  }, {
    path: "/c2c-nedir",
    component: _43bf8176,
    name: "c2c-nedir-345"
  }, {
    path: "/sevk-irsaliyesi-nedir-sevk-irsaliyesi-fatura-yerine-gecer-mi",
    component: _43bf8176,
    name: "sevk-irsaliyesi-nedir-sevk-irsaliyesi-fatura-yerine-gecer-mi-38"
  }, {
    path: "/690-hesap-nedir",
    component: _43bf8176,
    name: "690-hesap-nedir-376"
  }, {
    path: "/e-fatura-mukellefi-kimdir",
    component: _43bf8176,
    name: "e-fatura-mukellefi-kimdir-470"
  }, {
    path: "/tevkifatli-fatura-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "tevkifatli-fatura-muhasebe-kaydi-nasil-yapilir-241"
  }, {
    path: "/firin-isletmelerinde-muhasebe-programi-nasil-tutulur",
    component: _43bf8176,
    name: "firin-isletmelerinde-muhasebe-programi-nasil-tutulur-233"
  }, {
    path: "/gumruk-vergisi-nasil-hesaplanir",
    component: _43bf8176,
    name: "gumruk-vergisi-nasil-hesaplanir-433"
  }, {
    path: "/fatura-ornegi-faturada-hangi-bilgiler-yer-almali",
    component: _43bf8176,
    name: "fatura-ornegi-faturada-hangi-bilgiler-yer-almali-204"
  }, {
    path: "/e-doviz-alim-satim-belgesi-nedir",
    component: _43bf8176,
    name: "e-doviz-alim-satim-belgesi-nedir-182"
  }, {
    path: "/netten-brute-maas-hesaplama",
    component: _43bf8176,
    name: "netten-brute-maas-hesaplama-2"
  }, {
    path: "/reeskont-nedir-reeskont-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "reeskont-nedir-reeskont-muhasebe-kaydi-nasil-yapilir-410"
  }, {
    path: "/570-hesap",
    component: _43bf8176,
    name: "570-hesap-451"
  }, {
    path: "/vergi-borcu-yoktur-yazisi-nasil-alinir-ne-kadar-sureyle-gecerlidir",
    component: _43bf8176,
    name: "vergi-borcu-yoktur-yazisi-nasil-alinir-ne-kadar-sureyle-gecerlidir-132"
  }, {
    path: "/marka-tescil-sorgulama-nasil-yapilir",
    component: _43bf8176,
    name: "marka-tescil-sorgulama-nasil-yapilir-125"
  }, {
    path: "/istisna-faturasi-nedir",
    component: _43bf8176,
    name: "istisna-faturasi-nedir-306"
  }, {
    path: "/kdv-2-nedir-kdv-2-hesaplamasi-nasil-yapilir",
    component: _43bf8176,
    name: "kdv-2-nedir-kdv-2-hesaplamasi-nasil-yapilir-78"
  }, {
    path: "/fatura-kesmemenin-cezasi-nedir",
    component: _43bf8176,
    name: "fatura-kesmemenin-cezasi-nedir-29"
  }, {
    path: "/adat-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "adat-nedir-nasil-hesaplanir-1"
  }, {
    path: "/e-beyanname-nedir",
    component: _43bf8176,
    name: "e-beyanname-nedir-335"
  }, {
    path: "/e-imza-nedir-nereden-ve-nasil-alinir",
    component: _43bf8176,
    name: "e-imza-nedir-nereden-ve-nasil-alinir-224"
  }, {
    path: "/kdv-tevkifati-nasil-hesaplanir",
    component: _43bf8176,
    name: "kdv-tevkifati-nasil-hesaplanir-349"
  }, {
    path: "/ilisiksizlik-belgesi-nedir-sgk-ilisiksizlik-belgesi-basvurusu-nasil-yapilir",
    component: _43bf8176,
    name: "ilisiksizlik-belgesi-nedir-sgk-ilisiksizlik-belgesi-basvurusu-nasil-yapilir-316"
  }, {
    path: "/anonim-sirketi-nedir-genel-esas-ve-yukumlulukleri-nelerdir",
    component: _43bf8176,
    name: "anonim-sirketi-nedir-genel-esas-ve-yukumlulukleri-nelerdir-212"
  }, {
    path: "/kisa-vadeli-yabanci-kaynaklar-nelerdir",
    component: _43bf8176,
    name: "kisa-vadeli-yabanci-kaynaklar-nelerdir-315"
  }, {
    path: "/gelir-vergisi-beyannamesi-nedir-ne-zaman-verilir",
    component: _43bf8176,
    name: "gelir-vergisi-beyannamesi-nedir-ne-zaman-verilir-38"
  }, {
    path: "/calisma-arkadaslarinizla-nasil-online-dosya-paylasimi-yapabilirsiniz",
    component: _43bf8176,
    name: "calisma-arkadaslarinizla-nasil-online-dosya-paylasimi-yapabilirsiniz-109"
  }, {
    path: "/vergi-yansimasi-nedir",
    component: _43bf8176,
    name: "vergi-yansimasi-nedir-242"
  }, {
    path: "/dis-ticaret-nedir-dis-ticaret-yaparken-hangi-adimlar-izlenmelidir",
    component: _43bf8176,
    name: "dis-ticaret-nedir-dis-ticaret-yaparken-hangi-adimlar-izlenmelidir-294"
  }, {
    path: "/sirket-birlesmesi-islemleri-nelerdir",
    component: _43bf8176,
    name: "sirket-birlesmesi-islemleri-nelerdir-464"
  }, {
    path: "/tellaliye-sozlesmesi-nedir",
    component: _43bf8176,
    name: "tellaliye-sozlesmesi-nedir-171"
  }, {
    path: "/instagram-satis-vergisi-ile-ilgili-bilmeniz-gerekenler",
    component: _43bf8176,
    name: "instagram-satis-vergisi-ile-ilgili-bilmeniz-gerekenler-329"
  }, {
    path: "/e-ticaret-kargo-entegrasyonu-nedir",
    component: _43bf8176,
    name: "e-ticaret-kargo-entegrasyonu-nedir-266"
  }, {
    path: "/telif-hakki-nedir",
    component: _43bf8176,
    name: "telif-hakki-nedir-24"
  }, {
    path: "/enflasyon-nedir-nasil-hesaplanir-neden-yukselir-nasil-duser",
    component: _43bf8176,
    name: "enflasyon-nedir-nasil-hesaplanir-neden-yukselir-nasil-duser-458"
  }, {
    path: "/fazla-mesai-ucreti-nasil-hesaplanir",
    component: _43bf8176,
    name: "fazla-mesai-ucreti-nasil-hesaplanir-363"
  }, {
    path: "/ihbar-suresi-nedir-ihbar-suresi-hesaplama",
    component: _43bf8176,
    name: "ihbar-suresi-nedir-ihbar-suresi-hesaplama-485"
  }, {
    path: "/yurt-disina-urun-satisi-nasil-yapilir",
    component: _43bf8176,
    name: "yurt-disina-urun-satisi-nasil-yapilir-379"
  }, {
    path: "/hesap-mutabakat-formu",
    component: _43bf8176,
    name: "hesap-mutabakat-formu-454"
  }, {
    path: "/network-marketing-nedir",
    component: _43bf8176,
    name: "network-marketing-nedir-55"
  }, {
    path: "/brut-satis-nedir",
    component: _43bf8176,
    name: "brut-satis-nedir-166"
  }, {
    path: "/ihrac-kayitli-fatura-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "ihrac-kayitli-fatura-muhasebe-kaydi-nasil-yapilir-22"
  }, {
    path: "/ticari-fatura-nedir",
    component: _43bf8176,
    name: "ticari-fatura-nedir-137"
  }, {
    path: "/surec-yonetimi-nedir",
    component: _43bf8176,
    name: "surec-yonetimi-nedir-468"
  }, {
    path: "/120-hesap",
    component: _43bf8176,
    name: "120-hesap-346"
  }, {
    path: "/uretim-planlamasi-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "uretim-planlamasi-nedir-nasil-yapilir-385"
  }, {
    path: "/kurumlar-vergisi-istisnalari-nelerdir",
    component: _43bf8176,
    name: "kurumlar-vergisi-istisnalari-nelerdir-435"
  }, {
    path: "/yillik-izin-ucreti-nasil-hesaplanir",
    component: _43bf8176,
    name: "yillik-izin-ucreti-nasil-hesaplanir-296"
  }, {
    path: "/ba-bs-nedir-ba-bs-duzeltme-nasil-verilir",
    component: _43bf8176,
    name: "ba-bs-nedir-ba-bs-duzeltme-nasil-verilir-318"
  }, {
    path: "/borc-cesitleri-nelerdir",
    component: _43bf8176,
    name: "borc-cesitleri-nelerdir-419"
  }, {
    path: "/mustahsil-makbuzu-stopaj-orani-hesaplamasi-nasil-yapilir",
    component: _43bf8176,
    name: "mustahsil-makbuzu-stopaj-orani-hesaplamasi-nasil-yapilir-247"
  }, {
    path: "/e-defter-beyan-sistemi-nedir-nasil-kullanilir",
    component: _43bf8176,
    name: "e-defter-beyan-sistemi-nedir-nasil-kullanilir-204"
  }, {
    path: "/eBay-satis-rehberi",
    component: _43bf8176,
    name: "eBay-satis-rehberi-484"
  }, {
    path: "/591-hesap",
    component: _43bf8176,
    name: "591-hesap-18"
  }, {
    path: "/692-hesap",
    component: _43bf8176,
    name: "692-hesap-131"
  }, {
    path: "/noropazarlama-nedir",
    component: _43bf8176,
    name: "noropazarlama-nedir-69"
  }, {
    path: "/ciro-nedir",
    component: _43bf8176,
    name: "ciro-nedir-313"
  }, {
    path: "/sirket-ismi-nasil-secilir-nasil-tescil-edilir",
    component: _43bf8176,
    name: "sirket-ismi-nasil-secilir-nasil-tescil-edilir-379"
  }, {
    path: "/e-imza-ile-mali-muhur-arasindaki-fark-nedir-kim-hangisine-basvurmali",
    component: _43bf8176,
    name: "e-imza-ile-mali-muhur-arasindaki-fark-nedir-kim-hangisine-basvurmali-112"
  }, {
    path: "/yeni-airbnb-yasasi",
    component: _43bf8176,
    name: "yeni-airbnb-yasasi-330"
  }, {
    path: "/kurumlar-vergisi-mukellefleri-kimlerdir",
    component: _43bf8176,
    name: "kurumlar-vergisi-mukellefleri-kimlerdir-332"
  }, {
    path: "/konkordato-nedir",
    component: _43bf8176,
    name: "konkordato-nedir-95"
  }, {
    path: "/602-hesap-nedir",
    component: _43bf8176,
    name: "602-hesap-nedir-355"
  }, {
    path: "/689-hesap-nedir",
    component: _43bf8176,
    name: "689-hesap-nedir-355"
  }, {
    path: "/irsaliyeli-fatura-nedir",
    component: _43bf8176,
    name: "irsaliyeli-fatura-nedir-207"
  }, {
    path: "/muhasebe-fisi-turleri-nelerdir",
    component: _43bf8176,
    name: "muhasebe-fisi-turleri-nelerdir-133"
  }, {
    path: "/258-hesap-nedir",
    component: _43bf8176,
    name: "258-hesap-nedir-462"
  }, {
    path: "/yurt-disi-bankalarindan-nasil-kredi-cekilir",
    component: _43bf8176,
    name: "yurt-disi-bankalarindan-nasil-kredi-cekilir-419"
  }, {
    path: "/maas-avansi-nedir-avans-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "maas-avansi-nedir-avans-muhasebe-kaydi-nasil-yapilir-446"
  }, {
    path: "/e-irsaliye-basvurusu-nasil-yapilir",
    component: _43bf8176,
    name: "e-irsaliye-basvurusu-nasil-yapilir-12"
  }, {
    path: "/681-hesap",
    component: _43bf8176,
    name: "681-hesap-454"
  }, {
    path: "/pazarlama-plani-nedir-pazarlama-plani-nasil-hazirlanir",
    component: _43bf8176,
    name: "pazarlama-plani-nedir-pazarlama-plani-nasil-hazirlanir-120"
  }, {
    path: "/bilesik-getiri-nedir",
    component: _43bf8176,
    name: "bilesik-getiri-nedir-8"
  }, {
    path: "/e-mevduat-nedir-e-mevduat-hesabi-nasil-acilir",
    component: _43bf8176,
    name: "e-mevduat-nedir-e-mevduat-hesabi-nasil-acilir-216"
  }, {
    path: "/126-hesap",
    component: _43bf8176,
    name: "126-hesap-268"
  }, {
    path: "/muhasebe-ici-envanter-nedir",
    component: _43bf8176,
    name: "muhasebe-ici-envanter-nedir-140"
  }, {
    path: "/e-arsiv-fatura-nasil-goruntulenir",
    component: _43bf8176,
    name: "e-arsiv-fatura-nasil-goruntulenir-279"
  }, {
    path: "/personel-maliyeti-nasil-hesaplanir",
    component: _43bf8176,
    name: "personel-maliyeti-nasil-hesaplanir-15"
  }, {
    path: "/sirket-gider-kalemleri",
    component: _43bf8176,
    name: "sirket-gider-kalemleri-34"
  }, {
    path: "/savunma-ve-tutanak-nasil-hazirlanir",
    component: _43bf8176,
    name: "savunma-ve-tutanak-nasil-hazirlanir-143"
  }, {
    path: "/kasa-hesabi-nedir",
    component: _43bf8176,
    name: "kasa-hesabi-nedir-321"
  }, {
    path: "/temel-fatura-ile-ticari-fatura-arasindaki-fark-nedir",
    component: _43bf8176,
    name: "temel-fatura-ile-ticari-fatura-arasindaki-fark-nedir-445"
  }, {
    path: "/stopaj-vergisi-nedir",
    component: _43bf8176,
    name: "stopaj-vergisi-nedir-438"
  }, {
    path: "/198-hesap",
    component: _43bf8176,
    name: "198-hesap-139"
  }, {
    path: "/gomulu-finans",
    component: _43bf8176,
    name: "gomulu-finans-207"
  }, {
    path: "/kurumsal-risk-yonetimi",
    component: _43bf8176,
    name: "kurumsal-risk-yonetimi-207"
  }, {
    path: "/sgk-e-kesinti-uygulamasi-nedir-tarimsal-kesinti-icin-e-sgk-uygulamasi-nasil-kullanilir",
    component: _43bf8176,
    name: "sgk-e-kesinti-uygulamasi-nedir-tarimsal-kesinti-icin-e-sgk-uygulamasi-nasil-kullanilir-415"
  }, {
    path: "/mali-musavir-nedir-ne-is-yapar",
    component: _43bf8176,
    name: "mali-musavir-nedir-ne-is-yapar-137"
  }, {
    path: "/toplam-maliyet-nedir",
    component: _43bf8176,
    name: "toplam-maliyet-nedir-238"
  }, {
    path: "/e-ticaret-ortakligi-nedir",
    component: _43bf8176,
    name: "e-ticaret-ortakligi-nedir-407"
  }, {
    path: "/sahis-sirketi-ile-limited-sirket-arasindaki-farklar",
    component: _43bf8176,
    name: "sahis-sirketi-ile-limited-sirket-arasindaki-farklar-70"
  }, {
    path: "/serbest-ticaret-anlasmasi-nedir",
    component: _43bf8176,
    name: "serbest-ticaret-anlasmasi-nedir-11"
  }, {
    path: "/reddiyat-makbuzu",
    component: _43bf8176,
    name: "reddiyat-makbuzu-118"
  }, {
    path: "/620-hesap",
    component: _43bf8176,
    name: "620-hesap-260"
  }, {
    path: "/ihbar-tazminati-nedir",
    component: _43bf8176,
    name: "ihbar-tazminati-nedir-70"
  }, {
    path: "/gelir-belgesi-nedir-gelir-belgesi-nerden-alinir",
    component: _43bf8176,
    name: "gelir-belgesi-nedir-gelir-belgesi-nerden-alinir-145"
  }, {
    path: "/549-hesap",
    component: _43bf8176,
    name: "549-hesap-458"
  }, {
    path: "/engelli-emekliligi",
    component: _43bf8176,
    name: "engelli-emekliligi-303"
  }, {
    path: "/610-hesap-nedir",
    component: _43bf8176,
    name: "610-hesap-nedir-211"
  }, {
    path: "/yansitma-faturasi-nedir",
    component: _43bf8176,
    name: "yansitma-faturasi-nedir-486"
  }, {
    path: "/sermaye-artirimi-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "sermaye-artirimi-muhasebe-kaydi-nasil-yapilir-154"
  }, {
    path: "/rekabet-analizi-nedir",
    component: _43bf8176,
    name: "rekabet-analizi-nedir-240"
  }, {
    path: "/insaat-muhasebe-programi-nedir",
    component: _43bf8176,
    name: "insaat-muhasebe-programi-nedir-281"
  }, {
    path: "/e-donusum-rehberi",
    component: _43bf8176,
    name: "e-donusum-rehberi-445"
  }, {
    path: "/irsaliye-ve-fatura-arasindaki-farklar-nelerdir",
    component: _43bf8176,
    name: "irsaliye-ve-fatura-arasindaki-farklar-nelerdir-231"
  }, {
    path: "/huzur-hakki-nedir-huzur-hakki-hesaplamasi",
    component: _43bf8176,
    name: "huzur-hakki-nedir-huzur-hakki-hesaplamasi-242"
  }, {
    path: "/e-ihracat-faturasi-nasil-kesilir",
    component: _43bf8176,
    name: "e-ihracat-faturasi-nasil-kesilir-2"
  }, {
    path: "/iskonto-faturasi-nedir",
    component: _43bf8176,
    name: "iskonto-faturasi-nedir-42"
  }, {
    path: "/dijital-donusum-nedir",
    component: _43bf8176,
    name: "dijital-donusum-nedir-417"
  }, {
    path: "/tuzel-kisi-ne-demektir",
    component: _43bf8176,
    name: "tuzel-kisi-ne-demektir-266"
  }, {
    path: "/personel-devam-kontrol-sistemi-pkds-nedir",
    component: _43bf8176,
    name: "personel-devam-kontrol-sistemi-pkds-nedir-271"
  }, {
    path: "/hizmet-sozlesmesi-nedir",
    component: _43bf8176,
    name: "hizmet-sozlesmesi-nedir-231"
  }, {
    path: "/e-adisyon-nedir",
    component: _43bf8176,
    name: "e-adisyon-nedir-4"
  }, {
    path: "/sermaye-sirketi-nedir",
    component: _43bf8176,
    name: "sermaye-sirketi-nedir-470"
  }, {
    path: "/erp-programi-nedir-neden-kullanilmalidir",
    component: _43bf8176,
    name: "erp-programi-nedir-neden-kullanilmalidir-87"
  }, {
    path: "/ozel-entegrator-nedir",
    component: _43bf8176,
    name: "ozel-entegrator-nedir-176"
  }, {
    path: "/259-hesap",
    component: _43bf8176,
    name: "259-hesap-272"
  }, {
    path: "/mikro-asistan-guncelleme-nedir",
    component: _43bf8176,
    name: "mikro-asistan-guncelleme-nedir-361"
  }, {
    path: "/neden-crm-kullanmalisiniz",
    component: _43bf8176,
    name: "neden-crm-kullanmalisiniz-223"
  }, {
    path: "/meslek-kodu-nedir",
    component: _43bf8176,
    name: "meslek-kodu-nedir-151"
  }, {
    path: "/e-smm-nedir-neden-ve-nasil-kullanilir",
    component: _43bf8176,
    name: "e-smm-nedir-neden-ve-nasil-kullanilir-365"
  }, {
    path: "/e-defter-zorunlulugu",
    component: _43bf8176,
    name: "e-defter-zorunlulugu-215"
  }, {
    path: "/kapasite-gelistirme-raporu-nedir-neden-onemlidir",
    component: _43bf8176,
    name: "kapasite-gelistirme-raporu-nedir-neden-onemlidir-70"
  }, {
    path: "/findeks-raporu-nedir",
    component: _43bf8176,
    name: "findeks-raporu-nedir-68"
  }, {
    path: "/yurt-disinda-sirket-kurmak",
    component: _43bf8176,
    name: "yurt-disinda-sirket-kurmak-465"
  }, {
    path: "/yatirim-tesvik-belgesi-nedir-hedefleri-nelerdir",
    component: _43bf8176,
    name: "yatirim-tesvik-belgesi-nedir-hedefleri-nelerdir-425"
  }, {
    path: "/favok-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "favok-nedir-nasil-hesaplanir-80"
  }, {
    path: "/komandit-sirket-nedir",
    component: _43bf8176,
    name: "komandit-sirket-nedir-5"
  }, {
    path: "/lojistik-yonetimi-nedir",
    component: _43bf8176,
    name: "lojistik-yonetimi-nedir-254"
  }, {
    path: "/pazar-ve-pazar-payi-nedir",
    component: _43bf8176,
    name: "pazar-ve-pazar-payi-nedir-150"
  }, {
    path: "/ticaret-sicil-numarasi-nasil-alinir",
    component: _43bf8176,
    name: "ticaret-sicil-numarasi-nasil-alinir-154"
  }, {
    path: "/ihracat-e-fatura-uygulamasinda-sikca-sorulan-sorular",
    component: _43bf8176,
    name: "ihracat-e-fatura-uygulamasinda-sikca-sorulan-sorular-122"
  }, {
    path: "/asgari-kurumlar-vergisi",
    component: _43bf8176,
    name: "asgari-kurumlar-vergisi-65"
  }, {
    path: "/gercek-usul-vergi-nedir",
    component: _43bf8176,
    name: "gercek-usul-vergi-nedir-494"
  }, {
    path: "/tapu-harci-matrahi-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "tapu-harci-matrahi-nedir-nasil-hesaplanir-204"
  }, {
    path: "/mikro-ihracat-nedir",
    component: _43bf8176,
    name: "mikro-ihracat-nedir-179"
  }, {
    path: "/dokuman-yonetim-sistemi-nedir",
    component: _43bf8176,
    name: "dokuman-yonetim-sistemi-nedir-474"
  }, {
    path: "/vergi-numarasi-sorgulama-nasil-yapilir",
    component: _43bf8176,
    name: "vergi-numarasi-sorgulama-nasil-yapilir-283"
  }, {
    path: "/indirimli-kurumlar-vergisi-nedir",
    component: _43bf8176,
    name: "indirimli-kurumlar-vergisi-nedir-240"
  }, {
    path: "/pasif-gelir-nedir",
    component: _43bf8176,
    name: "pasif-gelir-nedir-304"
  }, {
    path: "/resmi-tatil-mesai-ucreti-nasil-hesaplanir",
    component: _43bf8176,
    name: "resmi-tatil-mesai-ucreti-nasil-hesaplanir-25"
  }, {
    path: "/sgk-e-vizite-hangi-durumlarda-kullanilir",
    component: _43bf8176,
    name: "sgk-e-vizite-hangi-durumlarda-kullanilir-5"
  }, {
    path: "/cek-cirolamak-nedir",
    component: _43bf8176,
    name: "cek-cirolamak-nedir-349"
  }, {
    path: "/inovasyon-nedir",
    component: _43bf8176,
    name: "inovasyon-nedir-272"
  }, {
    path: "/dahilde-isleme-rejimi-nedir",
    component: _43bf8176,
    name: "dahilde-isleme-rejimi-nedir-258"
  }, {
    path: "/hizmet-ihracati-nedir",
    component: _43bf8176,
    name: "hizmet-ihracati-nedir-35"
  }, {
    path: "/kolektif-sirket-nedir",
    component: _43bf8176,
    name: "kolektif-sirket-nedir-151"
  }, {
    path: "/502-hesap-nedir",
    component: _43bf8176,
    name: "502-hesap-nedir-482"
  }, {
    path: "/katma-deger-vergisi-kdv-nedir-kdv-ne-zaman-odenir",
    component: _43bf8176,
    name: "katma-deger-vergisi-kdv-nedir-kdv-ne-zaman-odenir-365"
  }, {
    path: "/ozel-maliyetler-hesabi-nedir-nasil-muhasebelestirilir",
    component: _43bf8176,
    name: "ozel-maliyetler-hesabi-nedir-nasil-muhasebelestirilir-342"
  }, {
    path: "/altin-faturasinin-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "altin-faturasinin-muhasebe-kaydi-nasil-yapilir-45"
  }, {
    path: "/yalin-uretim-nedir",
    component: _43bf8176,
    name: "yalin-uretim-nedir-186"
  }, {
    path: "/gini-katsayisi-nedir",
    component: _43bf8176,
    name: "gini-katsayisi-nedir-88"
  }, {
    path: "/253-hesap-nedir",
    component: _43bf8176,
    name: "253-hesap-nedir-140"
  }, {
    path: "/vergi-carpani-nedir",
    component: _43bf8176,
    name: "vergi-carpani-nedir-301"
  }, {
    path: "/vergi-dilimi-oranlari-nelerdir",
    component: _43bf8176,
    name: "vergi-dilimi-oranlari-nelerdir-482"
  }, {
    path: "/gerilla-pazarlamasi-",
    component: _43bf8176,
    name: "gerilla-pazarlamasi--99"
  }, {
    path: "/fiyat-farki-faturasi-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "fiyat-farki-faturasi-muhasebe-kaydi-nasil-yapilir-9"
  }, {
    path: "/ayni-vergi-nedir",
    component: _43bf8176,
    name: "ayni-vergi-nedir-370"
  }, {
    path: "/satis-maliyeti-nasil-hesaplanir",
    component: _43bf8176,
    name: "satis-maliyeti-nasil-hesaplanir-235"
  }, {
    path: "/aylik-prim-ve-hizmet-belgesi-aphb-nedir",
    component: _43bf8176,
    name: "aylik-prim-ve-hizmet-belgesi-aphb-nedir-123"
  }, {
    path: "/e-mutabakat-nedir",
    component: _43bf8176,
    name: "e-mutabakat-nedir-225"
  }, {
    path: "/excel-yerine-on-muhasebe-programi-kullanmak-icin-nedenler",
    component: _43bf8176,
    name: "excel-yerine-on-muhasebe-programi-kullanmak-icin-nedenler-359"
  }, {
    path: "/pazar-arastirmasi-nedir",
    component: _43bf8176,
    name: "pazar-arastirmasi-nedir-419"
  }, {
    path: "/toptancilik-nedir",
    component: _43bf8176,
    name: "toptancilik-nedir-329"
  }, {
    path: "/tam-zamaninda-uretim-jit-nedir",
    component: _43bf8176,
    name: "tam-zamaninda-uretim-jit-nedir-143"
  }, {
    path: "/finansal-gider-kisitlamasi",
    component: _43bf8176,
    name: "finansal-gider-kisitlamasi-246"
  }, {
    path: "/kombine-tasimacilik",
    component: _43bf8176,
    name: "kombine-tasimacilik-451"
  }, {
    path: "/SWOT-analizi-nedir",
    component: _43bf8176,
    name: "SWOT-analizi-nedir-466"
  }, {
    path: "/gelir-vergisi-nedir",
    component: _43bf8176,
    name: "gelir-vergisi-nedir-42"
  }, {
    path: "/kumulatif-vergi-matrahi-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "kumulatif-vergi-matrahi-nedir-nasil-hesaplanir-423"
  }, {
    path: "/milli-gelir-muhasebesi-nedir",
    component: _43bf8176,
    name: "milli-gelir-muhasebesi-nedir-92"
  }, {
    path: "/dijital-ikiz-teknolojisi",
    component: _43bf8176,
    name: "dijital-ikiz-teknolojisi-427"
  }, {
    path: "/hakli-ve-haksiz-fesih",
    component: _43bf8176,
    name: "hakli-ve-haksiz-fesih-460"
  }, {
    path: "/cari-oran-nasil-hesaplanir",
    component: _43bf8176,
    name: "cari-oran-nasil-hesaplanir-218"
  }, {
    path: "/pazaryeri-entegrasyonu-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "pazaryeri-entegrasyonu-nedir-nasil-yapilir-185"
  }, {
    path: "/kadin-girisimcilere-destek-veren-platformlar-nelerdir",
    component: _43bf8176,
    name: "kadin-girisimcilere-destek-veren-platformlar-nelerdir-206"
  }, {
    path: "/dijital-atik-nedir",
    component: _43bf8176,
    name: "dijital-atik-nedir-154"
  }, {
    path: "/157-hesap",
    component: _43bf8176,
    name: "157-hesap-263"
  }, {
    path: "/insaatta-fiyat-eskalasyonu-nasil-hesaplanir",
    component: _43bf8176,
    name: "insaatta-fiyat-eskalasyonu-nasil-hesaplanir-11"
  }, {
    path: "/bilgi-fisi-nedir-bilgi-fisi-nasil-hazirlanir",
    component: _43bf8176,
    name: "bilgi-fisi-nedir-bilgi-fisi-nasil-hazirlanir-470"
  }, {
    path: "/sirket-kuculmesi",
    component: _43bf8176,
    name: "sirket-kuculmesi-26"
  }, {
    path: "/vergi-takozu-nedir",
    component: _43bf8176,
    name: "vergi-takozu-nedir-58"
  }, {
    path: "/nace-kodu-sorgulama-nasil-yapilir",
    component: _43bf8176,
    name: "nace-kodu-sorgulama-nasil-yapilir-219"
  }, {
    path: "/intermodal-tasimacilik",
    component: _43bf8176,
    name: "intermodal-tasimacilik-5"
  }, {
    path: "/konsinye-irsaliyesi-nedir",
    component: _43bf8176,
    name: "konsinye-irsaliyesi-nedir-131"
  }, {
    path: "/portekizde-sirket-kurmak",
    component: _43bf8176,
    name: "portekizde-sirket-kurmak-326"
  }, {
    path: "/fintech-nedir",
    component: _43bf8176,
    name: "fintech-nedir-288"
  }, {
    path: "/dekont-ve-e-dekont-nedir-nasil-alinir",
    component: _43bf8176,
    name: "dekont-ve-e-dekont-nedir-nasil-alinir-34"
  }, {
    path: "/esnaf-vergi-muafiyeti-nedir-esnaf-vergi-muafiyet-belgesi-nasil-alinir",
    component: _43bf8176,
    name: "esnaf-vergi-muafiyeti-nedir-esnaf-vergi-muafiyet-belgesi-nasil-alinir-294"
  }, {
    path: "/e-fatura-kullanan-e-defter-de-kullanmak-zorunda-mi",
    component: _43bf8176,
    name: "e-fatura-kullanan-e-defter-de-kullanmak-zorunda-mi-364"
  }, {
    path: "/gayri-safi-hasilat-nedir",
    component: _43bf8176,
    name: "gayri-safi-hasilat-nedir-421"
  }, {
    path: "/e-haciz-nedir-nasil-kaldirilir",
    component: _43bf8176,
    name: "e-haciz-nedir-nasil-kaldirilir-179"
  }, {
    path: "/adli-muhasebe",
    component: _43bf8176,
    name: "adli-muhasebe-160"
  }, {
    path: "/e-fatura-gonderme-suresi-nedir",
    component: _43bf8176,
    name: "e-fatura-gonderme-suresi-nedir-385"
  }, {
    path: "/dijital-pazarlama-nedir",
    component: _43bf8176,
    name: "dijital-pazarlama-nedir-395"
  }, {
    path: "/resesyon-nedir",
    component: _43bf8176,
    name: "resesyon-nedir-480"
  }, {
    path: "/tediye-makbuzu-nedir",
    component: _43bf8176,
    name: "tediye-makbuzu-nedir-252"
  }, {
    path: "/tevkifat-faturasi-nasil-kesilir",
    component: _43bf8176,
    name: "tevkifat-faturasi-nasil-kesilir-379"
  }, {
    path: "/nesnelerin-interneti-iot-nedir",
    component: _43bf8176,
    name: "nesnelerin-interneti-iot-nedir-305"
  }, {
    path: "/kobi-belgesi-nedir",
    component: _43bf8176,
    name: "kobi-belgesi-nedir-136"
  }, {
    path: "/mustahsil-makbuzu-nedir-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "mustahsil-makbuzu-nedir-muhasebe-kaydi-nasil-yapilir-170"
  }, {
    path: "/apostil-nedir",
    component: _43bf8176,
    name: "apostil-nedir-210"
  }, {
    path: "/bilanco-nedir",
    component: _43bf8176,
    name: "bilanco-nedir-279"
  }, {
    path: "/isletme-hesabi-defteri-nasil-tutulur",
    component: _43bf8176,
    name: "isletme-hesabi-defteri-nasil-tutulur-111"
  }, {
    path: "/bilancodan-isletmeye-gecis-isletmeden-bilancoya-gecis-nasil-olur",
    component: _43bf8176,
    name: "bilancodan-isletmeye-gecis-isletmeden-bilancoya-gecis-nasil-olur-224"
  }, {
    path: "/metaverse-nedir",
    component: _43bf8176,
    name: "metaverse-nedir-258"
  }, {
    path: "/stagflasyon-nedir-resesyonla-arasinda-ne-fark-vardir",
    component: _43bf8176,
    name: "stagflasyon-nedir-resesyonla-arasinda-ne-fark-vardir-180"
  }, {
    path: "/e-ticaret-icin-vergi-levhasi-nasil-alinir",
    component: _43bf8176,
    name: "e-ticaret-icin-vergi-levhasi-nasil-alinir-39"
  }, {
    path: "/kep-adresi-nasil-sorgulanir",
    component: _43bf8176,
    name: "kep-adresi-nasil-sorgulanir-339"
  }, {
    path: "/elle-iade-faturasi-nasil-kesilir",
    component: _43bf8176,
    name: "elle-iade-faturasi-nasil-kesilir-221"
  }, {
    path: "/e-ticarette-en-cok-kullanilan-konteyner-turleri",
    component: _43bf8176,
    name: "e-ticarette-en-cok-kullanilan-konteyner-turleri-33"
  }, {
    path: "/kurgan-nedir",
    component: _43bf8176,
    name: "kurgan-nedir-497"
  }, {
    path: "/e-arsiv-yurt-disi-fatura-nasil-kesilir",
    component: _43bf8176,
    name: "e-arsiv-yurt-disi-fatura-nasil-kesilir-107"
  }, {
    path: "/d2c-nedir",
    component: _43bf8176,
    name: "d2c-nedir-331"
  }, {
    path: "/e-ticaret-sirketi-nedir-nasil-kurulur",
    component: _43bf8176,
    name: "e-ticaret-sirketi-nedir-nasil-kurulur-272"
  }, {
    path: "/nazim-hesaplar-nedir",
    component: _43bf8176,
    name: "nazim-hesaplar-nedir-474"
  }, {
    path: "/evlilik-izni",
    component: _43bf8176,
    name: "evlilik-izni-40"
  }, {
    path: "/gider-makbuzu-nedir",
    component: _43bf8176,
    name: "gider-makbuzu-nedir-463"
  }, {
    path: "/engelli-vergi-indirimi",
    component: _43bf8176,
    name: "engelli-vergi-indirimi-477"
  }, {
    path: "/roi-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "roi-nedir-nasil-hesaplanir-167"
  }, {
    path: "/maas-bordrosu-nasil-alinir",
    component: _43bf8176,
    name: "maas-bordrosu-nasil-alinir-440"
  }, {
    path: "/esg-raporlamasi-nedir",
    component: _43bf8176,
    name: "esg-raporlamasi-nedir-73"
  }, {
    path: "/ozluk-dosyasi-nedir",
    component: _43bf8176,
    name: "ozluk-dosyasi-nedir-275"
  }, {
    path: "/perakendecilik-nedir",
    component: _43bf8176,
    name: "perakendecilik-nedir-42"
  }, {
    path: "/stopaj-nasil-hesaplanir",
    component: _43bf8176,
    name: "stopaj-nasil-hesaplanir-83"
  }, {
    path: "/yevmiye-defteri-nedir",
    component: _43bf8176,
    name: "yevmiye-defteri-nedir-70"
  }, {
    path: "/ruchan-hakki-nedir",
    component: _43bf8176,
    name: "ruchan-hakki-nedir-423"
  }, {
    path: "/kimler-vergi-mukellefidir",
    component: _43bf8176,
    name: "kimler-vergi-mukellefidir-381"
  }, {
    path: "/damga-vergisi-beyannamesi-nedir",
    component: _43bf8176,
    name: "damga-vergisi-beyannamesi-nedir-420"
  }, {
    path: "/bulut-depolama-nedir",
    component: _43bf8176,
    name: "bulut-depolama-nedir-385"
  }, {
    path: "/sahis-sirketi-nasil-kurulur",
    component: _43bf8176,
    name: "sahis-sirketi-nasil-kurulur-306"
  }, {
    path: "/veblen-etkisi-nedir",
    component: _43bf8176,
    name: "veblen-etkisi-nedir-68"
  }, {
    path: "/alistan-iade-muhasebe-kaydi-ile-satistan-iade-muhasebe-kaydi-nedir",
    component: _43bf8176,
    name: "alistan-iade-muhasebe-kaydi-ile-satistan-iade-muhasebe-kaydi-nedir-24"
  }, {
    path: "/tebligat-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "tebligat-nedir-ne-ise-yarar-370"
  }, {
    path: "/tevkifat-siniri-nedir",
    component: _43bf8176,
    name: "tevkifat-siniri-nedir-43"
  }, {
    path: "/242-istirakler-hesabi",
    component: _43bf8176,
    name: "242-istirakler-hesabi-50"
  }, {
    path: "/mikro-e-defter-bulutta-imzalama-nedir",
    component: _43bf8176,
    name: "mikro-e-defter-bulutta-imzalama-nedir-313"
  }, {
    path: "/isverenin-calisanina-karsi-yukumlulukleri-nelerdir",
    component: _43bf8176,
    name: "isverenin-calisanina-karsi-yukumlulukleri-nelerdir-347"
  }, {
    path: "/banka-doviz-kur-farki-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "banka-doviz-kur-farki-muhasebe-kaydi-nasil-yapilir-343"
  }, {
    path: "/damga-vergisi-nasil-odenir",
    component: _43bf8176,
    name: "damga-vergisi-nasil-odenir-47"
  }, {
    path: "/ticari-kazanc-nedir",
    component: _43bf8176,
    name: "ticari-kazanc-nedir-321"
  }, {
    path: "/vergi-levhasi-sorgulama-nasil-yapilir",
    component: _43bf8176,
    name: "vergi-levhasi-sorgulama-nasil-yapilir-325"
  }, {
    path: "/kok-neden-analizi-nasil-yapilir",
    component: _43bf8176,
    name: "kok-neden-analizi-nasil-yapilir-245"
  }, {
    path: "/mizan-nedir",
    component: _43bf8176,
    name: "mizan-nedir-339"
  }, {
    path: "/odeme-kaydedici-cihaz-alma-suresi-nedir",
    component: _43bf8176,
    name: "odeme-kaydedici-cihaz-alma-suresi-nedir-476"
  }, {
    path: "/duzeltme-beyannamesi-nedir",
    component: _43bf8176,
    name: "duzeltme-beyannamesi-nedir-99"
  }, {
    path: "/kdvsiz-fatura-kesmek-kdv-0-ise-fatura-nasil-kesilmeli",
    component: _43bf8176,
    name: "kdvsiz-fatura-kesmek-kdv-0-ise-fatura-nasil-kesilmeli-476"
  }, {
    path: "/is-plani-hazirlama",
    component: _43bf8176,
    name: "is-plani-hazirlama-294"
  }, {
    path: "/affiliate-marketing-nedir",
    component: _43bf8176,
    name: "affiliate-marketing-nedir-449"
  }, {
    path: "/ticari-defterler-nelerdir",
    component: _43bf8176,
    name: "ticari-defterler-nelerdir-318"
  }, {
    path: "/joint-venture-ortak-girisim-nedir",
    component: _43bf8176,
    name: "joint-venture-ortak-girisim-nedir-339"
  }, {
    path: "/muhasebe-hesap-kodlari-nelerdir",
    component: _43bf8176,
    name: "muhasebe-hesap-kodlari-nelerdir-183"
  }, {
    path: "/menkul-kiymetler-nedir",
    component: _43bf8176,
    name: "menkul-kiymetler-nedir-150"
  }, {
    path: "/ortalama-onarim-suresi-hesaplama",
    component: _43bf8176,
    name: "ortalama-onarim-suresi-hesaplama-221"
  }, {
    path: "/tek-ve-cift-tarafli-muhasebe-yontemleri",
    component: _43bf8176,
    name: "tek-ve-cift-tarafli-muhasebe-yontemleri-343"
  }, {
    path: "/isletmelerin-kisa-vadeli-finansman-kaynaklari-nelerdir",
    component: _43bf8176,
    name: "isletmelerin-kisa-vadeli-finansman-kaynaklari-nelerdir-170"
  }, {
    path: "/hasta-takip-programi-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "hasta-takip-programi-nedir-ne-ise-yarar-289"
  }, {
    path: "/web-tabanli-muhasebe-programinin-avantajlari",
    component: _43bf8176,
    name: "web-tabanli-muhasebe-programinin-avantajlari-441"
  }, {
    path: "/vuk-507-nedir",
    component: _43bf8176,
    name: "vuk-507-nedir-260"
  }, {
    path: "/melek-yatirimci-nedir",
    component: _43bf8176,
    name: "melek-yatirimci-nedir-32"
  }, {
    path: "/ucret-tahakkuk-kaydi-ile-ilgili-bilmeniz-gerekenler",
    component: _43bf8176,
    name: "ucret-tahakkuk-kaydi-ile-ilgili-bilmeniz-gerekenler-169"
  }, {
    path: "/banka-kredilerinin-muhasebelestirilmesi",
    component: _43bf8176,
    name: "banka-kredilerinin-muhasebelestirilmesi-440"
  }, {
    path: "/urun-agaci-bom-nedir",
    component: _43bf8176,
    name: "urun-agaci-bom-nedir-310"
  }, {
    path: "/kdv-beyannamesi-nedir-nasil-duzenlenir",
    component: _43bf8176,
    name: "kdv-beyannamesi-nedir-nasil-duzenlenir-281"
  }, {
    path: "/stopajsiz-serbest-meslek-makbuzu-nasil-kesilir",
    component: _43bf8176,
    name: "stopajsiz-serbest-meslek-makbuzu-nasil-kesilir-495"
  }, {
    path: "/ihtiyat-akcesi-nedir",
    component: _43bf8176,
    name: "ihtiyat-akcesi-nedir-430"
  }, {
    path: "/sahis-sirketleri-gelir-vergisi-oranlari-ve-hesaplamasi",
    component: _43bf8176,
    name: "sahis-sirketleri-gelir-vergisi-oranlari-ve-hesaplamasi-104"
  }, {
    path: "/bulut-erp-nedir",
    component: _43bf8176,
    name: "bulut-erp-nedir-39"
  }, {
    path: "/yesil-defter-nedir",
    component: _43bf8176,
    name: "yesil-defter-nedir-176"
  }, {
    path: "/ekonomi-sozlugu",
    component: _43bf8176,
    name: "ekonomi-sozlugu-13"
  }, {
    path: "/beyanname-nedir",
    component: _43bf8176,
    name: "beyanname-nedir-376"
  }, {
    path: "/ozel-tuketim-vergisi-otv-nedir",
    component: _43bf8176,
    name: "ozel-tuketim-vergisi-otv-nedir-309"
  }, {
    path: "/kira-beyannamesi-nedir-ve-nasil-hazirlanir",
    component: _43bf8176,
    name: "kira-beyannamesi-nedir-ve-nasil-hazirlanir-40"
  }, {
    path: "/lojistikte-ellecleme-nedir",
    component: _43bf8176,
    name: "lojistikte-ellecleme-nedir-390"
  }, {
    path: "/mes-nedir",
    component: _43bf8176,
    name: "mes-nedir-200"
  }, {
    path: "/barkod-nasil-olusturulur",
    component: _43bf8176,
    name: "barkod-nasil-olusturulur-236"
  }, {
    path: "/sirketler-neden-erp-kullanir-10-ihtiyac-cozumu",
    component: _43bf8176,
    name: "sirketler-neden-erp-kullanir-10-ihtiyac-cozumu-433"
  }, {
    path: "/konsolide-ve-konsolidasyon-nedir",
    component: _43bf8176,
    name: "konsolide-ve-konsolidasyon-nedir-456"
  }, {
    path: "/sic-kodu-nedir",
    component: _43bf8176,
    name: "sic-kodu-nedir-243"
  }, {
    path: "/hastane-otomasyon-programi-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "hastane-otomasyon-programi-nedir-ne-ise-yarar-277"
  }, {
    path: "/vergi-borcu-yapilandirma",
    component: _43bf8176,
    name: "vergi-borcu-yapilandirma-478"
  }, {
    path: "/girisimci-sosyal-yanilgilari",
    component: _43bf8176,
    name: "girisimci-sosyal-yanilgilari-318"
  }, {
    path: "/personel-yonetimi-programi-nedir",
    component: _43bf8176,
    name: "personel-yonetimi-programi-nedir-1"
  }, {
    path: "/proforma-fatura-nedir-nasil-hazirlanir",
    component: _43bf8176,
    name: "proforma-fatura-nedir-nasil-hazirlanir-21"
  }, {
    path: "/antrepo-nedir",
    component: _43bf8176,
    name: "antrepo-nedir-312"
  }, {
    path: "/kullanici-basina-ortalama-gelir-arpu-nedir-nasil-hesaplanir",
    component: _43bf8176,
    name: "kullanici-basina-ortalama-gelir-arpu-nedir-nasil-hesaplanir-68"
  }, {
    path: "/iade-faturasi-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "iade-faturasi-muhasebe-kaydi-nasil-yapilir-30"
  }, {
    path: "/blockchain-ve-ticari-yazilimlar",
    component: _43bf8176,
    name: "blockchain-ve-ticari-yazilimlar-296"
  }, {
    path: "/e-mustahsil-makbuzu-nedir-nasil-kesilir",
    component: _43bf8176,
    name: "e-mustahsil-makbuzu-nedir-nasil-kesilir-30"
  }, {
    path: "/dijital-sozlesme-nedir",
    component: _43bf8176,
    name: "dijital-sozlesme-nedir-58"
  }, {
    path: "/on-muhasebe-nedir",
    component: _43bf8176,
    name: "on-muhasebe-nedir-253"
  }, {
    path: "/kasa-defteri-nasil-tutulur",
    component: _43bf8176,
    name: "kasa-defteri-nasil-tutulur-274"
  }, {
    path: "/estonyada-sirket-kurmak-avantajlari-nelerdir-nasil-kurulur",
    component: _43bf8176,
    name: "estonyada-sirket-kurmak-avantajlari-nelerdir-nasil-kurulur-38"
  }, {
    path: "/yesil-lojistik-nedir",
    component: _43bf8176,
    name: "yesil-lojistik-nedir-427"
  }, {
    path: "/temel-fatura-iptali-nasil-yapilir",
    component: _43bf8176,
    name: "temel-fatura-iptali-nasil-yapilir-481"
  }, {
    path: "/vade-farki-nasil-muhasebelestirilir",
    component: _43bf8176,
    name: "vade-farki-nasil-muhasebelestirilir-453"
  }, {
    path: "/136-hesap-nedir",
    component: _43bf8176,
    name: "136-hesap-nedir-309"
  }, {
    path: "/dijital-hizmet-vergisi-nedir",
    component: _43bf8176,
    name: "dijital-hizmet-vergisi-nedir-152"
  }, {
    path: "/istirak-hissesi-satis-kazanci-istisnasi",
    component: _43bf8176,
    name: "istirak-hissesi-satis-kazanci-istisnasi-206"
  }, {
    path: "/enflasyon-muhasebesi-nedir",
    component: _43bf8176,
    name: "enflasyon-muhasebesi-nedir-265"
  }, {
    path: "/deflasyon-nedir",
    component: _43bf8176,
    name: "deflasyon-nedir-211"
  }, {
    path: "/is-zekasi-nedir",
    component: _43bf8176,
    name: "is-zekasi-nedir-229"
  }, {
    path: "/sgk-hizmet-dokumu-nedir",
    component: _43bf8176,
    name: "sgk-hizmet-dokumu-nedir-219"
  }, {
    path: "/veri-analitigi-nedir-veri-analitigi-turleri-nelerdir",
    component: _43bf8176,
    name: "veri-analitigi-nedir-veri-analitigi-turleri-nelerdir-354"
  }, {
    path: "/stok-karti-nedir",
    component: _43bf8176,
    name: "stok-karti-nedir-343"
  }, {
    path: "/aile-bildirim-formu-nedir-nasil-cikarilir",
    component: _43bf8176,
    name: "aile-bildirim-formu-nedir-nasil-cikarilir-374"
  }, {
    path: "/giffen-paradoksu",
    component: _43bf8176,
    name: "giffen-paradoksu-396"
  }, {
    path: "/isten-cikis-bildirgesi-ile-isten-ayrilis",
    component: _43bf8176,
    name: "isten-cikis-bildirgesi-ile-isten-ayrilis-38"
  }, {
    path: "/erp-raporlama-araclari-hangi-raporlari-verir",
    component: _43bf8176,
    name: "erp-raporlama-araclari-hangi-raporlari-verir-482"
  }, {
    path: "/transit-ticaret-nedir",
    component: _43bf8176,
    name: "transit-ticaret-nedir-201"
  }, {
    path: "/dark-store-karanlik-magaza-modeli",
    component: _43bf8176,
    name: "dark-store-karanlik-magaza-modeli-391"
  }, {
    path: "/potansiyel-musteri-nedir",
    component: _43bf8176,
    name: "potansiyel-musteri-nedir-83"
  }, {
    path: "/uluslararasi-finansal-raporlama-standartlari-ufrs-nedir",
    component: _43bf8176,
    name: "uluslararasi-finansal-raporlama-standartlari-ufrs-nedir-399"
  }, {
    path: "/benzersiz-satis-teklifi",
    component: _43bf8176,
    name: "benzersiz-satis-teklifi-239"
  }, {
    path: "/parite-nedir",
    component: _43bf8176,
    name: "parite-nedir-300"
  }, {
    path: "/santiye-takip-programi-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "santiye-takip-programi-nedir-ne-ise-yarar-407"
  }, {
    path: "/gekap-nedir",
    component: _43bf8176,
    name: "gekap-nedir-220"
  }, {
    path: "/mesafeli-satis-sozlesmesi-ornegi",
    component: _43bf8176,
    name: "mesafeli-satis-sozlesmesi-ornegi-365"
  }, {
    path: "/patent-nedir-nasil-alinir",
    component: _43bf8176,
    name: "patent-nedir-nasil-alinir-276"
  }, {
    path: "/prime-esas-kazanc-nedir",
    component: _43bf8176,
    name: "prime-esas-kazanc-nedir-302"
  }, {
    path: "/rpa-nedir-erp-sureclerinde-nerelerde-kullanilir",
    component: _43bf8176,
    name: "rpa-nedir-erp-sureclerinde-nerelerde-kullanilir-138"
  }, {
    path: "/istirak-nedir-istirak-cesitleri-nelerdir",
    component: _43bf8176,
    name: "istirak-nedir-istirak-cesitleri-nelerdir-464"
  }, {
    path: "/emekli-oldugumda-ne-kadar-maas-alirim",
    component: _43bf8176,
    name: "emekli-oldugumda-ne-kadar-maas-alirim-183"
  }, {
    path: "/toptan-giyimde-seri-tekleme-ve-asorti-nedir",
    component: _43bf8176,
    name: "toptan-giyimde-seri-tekleme-ve-asorti-nedir-342"
  }, {
    path: "/last-mile-son-kilometre-lojistigi",
    component: _43bf8176,
    name: "last-mile-son-kilometre-lojistigi-113"
  }, {
    path: "/cross-selling-capraz-satis-nedir",
    component: _43bf8176,
    name: "cross-selling-capraz-satis-nedir-220"
  }, {
    path: "/lifo-nedir",
    component: _43bf8176,
    name: "lifo-nedir-300"
  }, {
    path: "/iyi-bir-nakliye-programinda-bulunmasi-gereken-7-ozellik",
    component: _43bf8176,
    name: "iyi-bir-nakliye-programinda-bulunmasi-gereken-7-ozellik-67"
  }, {
    path: "/gelecegin-profesyonelleri-raporu",
    component: _43bf8176,
    name: "gelecegin-profesyonelleri-raporu-387"
  }, {
    path: "/pazarlama-karmasi-nedir",
    component: _43bf8176,
    name: "pazarlama-karmasi-nedir-37"
  }, {
    path: "/tis-nedir",
    component: _43bf8176,
    name: "tis-nedir-196"
  }, {
    path: "/serbest-meslek-makbuzu-smm-muhasebe-kaydi-nasil-yapilir",
    component: _43bf8176,
    name: "serbest-meslek-makbuzu-smm-muhasebe-kaydi-nasil-yapilir-260"
  }, {
    path: "/geksis-nedir-geksisi-kimler-kullanir",
    component: _43bf8176,
    name: "geksis-nedir-geksisi-kimler-kullanir-115"
  }, {
    path: "/ikame-ve-gelir-etkisi",
    component: _43bf8176,
    name: "ikame-ve-gelir-etkisi-17"
  }, {
    path: "/stok-maliyetlerinin-hesaplanmasi",
    component: _43bf8176,
    name: "stok-maliyetlerinin-hesaplanmasi-185"
  }, {
    path: "/finansal-piyasalar",
    component: _43bf8176,
    name: "finansal-piyasalar-492"
  }, {
    path: "/fire-hesaplama",
    component: _43bf8176,
    name: "fire-hesaplama-284"
  }, {
    path: "/muavin-defter-nedir-nasil-tutulur",
    component: _43bf8176,
    name: "muavin-defter-nedir-nasil-tutulur-219"
  }, {
    path: "/amortisman-nedir",
    component: _43bf8176,
    name: "amortisman-nedir-482"
  }, {
    path: "/fason-uretimi-nedir",
    component: _43bf8176,
    name: "fason-uretimi-nedir-198"
  }, {
    path: "/gss-prim-borcu-nedir",
    component: _43bf8176,
    name: "gss-prim-borcu-nedir-367"
  }, {
    path: "/hakedis-nedir",
    component: _43bf8176,
    name: "hakedis-nedir-232"
  }, {
    path: "/sgk-e-borcu-yoktur-uygulamasi-ile-ilgili-bilmeniz-gerekenler",
    component: _43bf8176,
    name: "sgk-e-borcu-yoktur-uygulamasi-ile-ilgili-bilmeniz-gerekenler-329"
  }, {
    path: "/sgk-ise-giris-bildirgesi-nedir-ne-zaman-verilir",
    component: _43bf8176,
    name: "sgk-ise-giris-bildirgesi-nedir-ne-zaman-verilir-145"
  }, {
    path: "/stok-devir-hizi-hesaplama",
    component: _43bf8176,
    name: "stok-devir-hizi-hesaplama-221"
  }, {
    path: "/maliyet-muhasebesi-nedir",
    component: _43bf8176,
    name: "maliyet-muhasebesi-nedir-359"
  }, {
    path: "/sirket-turleri-nelerdir",
    component: _43bf8176,
    name: "sirket-turleri-nelerdir-355"
  }, {
    path: "/instagram-reklamlari-hakkinda-bilmeniz-gereken-her-sey",
    component: _43bf8176,
    name: "instagram-reklamlari-hakkinda-bilmeniz-gereken-her-sey-30"
  }, {
    path: "/dijitallesme-nedir",
    component: _43bf8176,
    name: "dijitallesme-nedir-278"
  }, {
    path: "/plasiyer-satis-nedir",
    component: _43bf8176,
    name: "plasiyer-satis-nedir-383"
  }, {
    path: "/sirket-degeri-hesaplama",
    component: _43bf8176,
    name: "sirket-degeri-hesaplama-165"
  }, {
    path: "/deniz-yolu-tasimaciligi",
    component: _43bf8176,
    name: "deniz-yolu-tasimaciligi-403"
  }, {
    path: "/musteri-sadakati-nedir",
    component: _43bf8176,
    name: "musteri-sadakati-nedir-100"
  }, {
    path: "/nefes-kredisi-kimlere-verilir-sartlari-nelerdir",
    component: _43bf8176,
    name: "nefes-kredisi-kimlere-verilir-sartlari-nelerdir-445"
  }, {
    path: "/muhasebe-nedir",
    component: _43bf8176,
    name: "muhasebe-nedir-474"
  }, {
    path: "/upselling-nedir-nasil-yapilir",
    component: _43bf8176,
    name: "upselling-nedir-nasil-yapilir-175"
  }, {
    path: "/eko-tasarim-nedir-eko-tasarim-tuzugu-neden-onemli",
    component: _43bf8176,
    name: "eko-tasarim-nedir-eko-tasarim-tuzugu-neden-onemli-210"
  }, {
    path: "/insaat-maliyeti-hesaplama",
    component: _43bf8176,
    name: "insaat-maliyeti-hesaplama-105"
  }, {
    path: "/bedelsiz-sermaye-artirimi-nedir",
    component: _43bf8176,
    name: "bedelsiz-sermaye-artirimi-nedir-81"
  }, {
    path: "/internet-vergi-dairesi-ivd-nasil-kullanilir",
    component: _43bf8176,
    name: "internet-vergi-dairesi-ivd-nasil-kullanilir-124"
  }, {
    path: "/depo-takibi-nedir",
    component: _43bf8176,
    name: "depo-takibi-nedir-216"
  }, {
    path: "/kurum-gecici-vergi-nedir",
    component: _43bf8176,
    name: "kurum-gecici-vergi-nedir-67"
  }, {
    path: "/noter-makbuzu-muhasebe-kaydi-nasil-olur",
    component: _43bf8176,
    name: "noter-makbuzu-muhasebe-kaydi-nasil-olur-215"
  }, {
    path: "/ortulu-sermaye-hesaplama",
    component: _43bf8176,
    name: "ortulu-sermaye-hesaplama-6"
  }, {
    path: "/mrp-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "mrp-nedir-ne-ise-yarar-24"
  }, {
    path: "/mail-order-nedir-nasil-odeme-alinir-guvenli-mi-riskleri-nelerdir",
    component: _43bf8176,
    name: "mail-order-nedir-nasil-odeme-alinir-guvenli-mi-riskleri-nelerdir-334"
  }, {
    path: "/naylon-fatura-nedir",
    component: _43bf8176,
    name: "naylon-fatura-nedir-353"
  }, {
    path: "/karbon-ayak-izini-azaltan-uretim-stratejileri",
    component: _43bf8176,
    name: "karbon-ayak-izini-azaltan-uretim-stratejileri-351"
  }, {
    path: "/multimodal-tasimacilik-nedir",
    component: _43bf8176,
    name: "multimodal-tasimacilik-nedir-381"
  }, {
    path: "/defter-i-kebir-nedir-defter-i-kebir-ne-ise-yarar",
    component: _43bf8176,
    name: "defter-i-kebir-nedir-defter-i-kebir-ne-ise-yarar-484"
  }, {
    path: "/depo-personeli-ne-is-yapar",
    component: _43bf8176,
    name: "depo-personeli-ne-is-yapar-86"
  }, {
    path: "/fatura-yazdirma-programi-nedir-ne-ise-yarar",
    component: _43bf8176,
    name: "fatura-yazdirma-programi-nedir-ne-ise-yarar-443"
  }, {
    path: "/e-arsiv-faturanin-iadesi-nasil-yapilir",
    component: _43bf8176,
    name: "e-arsiv-faturanin-iadesi-nasil-yapilir-188"
  }, {
    path: "/hazir-degerler-nedir",
    component: _43bf8176,
    name: "hazir-degerler-nedir-327"
  }, {
    path: "/takas-ceki-nedir",
    component: _43bf8176,
    name: "takas-ceki-nedir-20"
  }, {
    path: "/limited-sirket-devri-nasil-olur",
    component: _43bf8176,
    name: "limited-sirket-devri-nasil-olur-86"
  }, {
    path: "/fifo-nedir",
    component: _43bf8176,
    name: "fifo-nedir-159"
  }, {
    path: "/kdv-iadesi-nedir-kdv-iadesi-nasil-alinir",
    component: _43bf8176,
    name: "kdv-iadesi-nedir-kdv-iadesi-nasil-alinir-218"
  }, {
    path: "/emsal-ucret-arastirmasi",
    component: _43bf8176,
    name: "emsal-ucret-arastirmasi-94"
  }, {
    path: "/cari-yaslandirma-nedir",
    component: _43bf8176,
    name: "cari-yaslandirma-nedir-45"
  }, {
    path: "/leasing-nedir",
    component: _43bf8176,
    name: "leasing-nedir-442"
  }, {
    path: "/api-nedir",
    component: _43bf8176,
    name: "api-nedir-9"
  }, {
    path: "/sgk-gecikme-zammi-nedir-sgk-gecikme-zammi-hesaplama-nasil-yapilir",
    component: _43bf8176,
    name: "sgk-gecikme-zammi-nedir-sgk-gecikme-zammi-hesaplama-nasil-yapilir-168"
  }, {
    path: "/elus-nedir-belgeleri-nelerdir",
    component: _43bf8176,
    name: "elus-nedir-belgeleri-nelerdir-422"
  }, {
    path: "/seo-nedir-nasil-calisir",
    component: _43bf8176,
    name: "seo-nedir-nasil-calisir-237"
  }, {
    path: "/odemeler-dengesi",
    component: _43bf8176,
    name: "odemeler-dengesi-423"
  }, {
    path: "/kanban-nedir",
    component: _43bf8176,
    name: "kanban-nedir-454"
  }, {
    path: "/e-bordro-nedir-neden-e-bordro-kullanmalisiniz",
    component: _43bf8176,
    name: "e-bordro-nedir-neden-e-bordro-kullanmalisiniz-375"
  }, {
    path: "/mikro-aradiginiz-cozum",
    component: _d6aa06ae,
    name: "mikro-aradiginiz-cozum-406"
  }, {
    path: "/mikro-aradiginiz-dikey-cozum",
    component: _d6aa06ae,
    name: "mikro-aradiginiz-dikey-cozum-172"
  }, {
    path: "/taksitli-odeme-kolayligi",
    component: _d6aa06ae,
    name: "taksitli-odeme-kolayligi-403"
  }, {
    path: "/bulten-uyelikten-ayril",
    component: _d6aa06ae,
    name: "bulten-uyelikten-ayril-335"
  }, {
    path: "/dikey-cozumler-indirim-kampanyasi-surec-yonetimi",
    component: _d6aa06ae,
    name: "dikey-cozumler-indirim-kampanyasi-surec-yonetimi-239"
  }, {
    path: "/fastsell-restoran-cozum",
    component: _d6aa06ae,
    name: "fastsell-restoran-cozum-58"
  }, {
    path: "/fastsell-hizli-satis-mikro",
    component: _d6aa06ae,
    name: "fastsell-hizli-satis-mikro-80"
  }, {
    path: "/mikro-depo-programi-ve-yazilimi",
    component: _d6aa06ae,
    name: "mikro-depo-programi-ve-yazilimi-255"
  }, {
    path: "/dikey-cozumler-indirim-kampanyasi-restoran",
    component: _d6aa06ae,
    name: "dikey-cozumler-indirim-kampanyasi-restoran-231"
  }, {
    path: "/dikey-cozumler-indirim-kampanyasi-mikro-hizli-satis",
    component: _d6aa06ae,
    name: "dikey-cozumler-indirim-kampanyasi-mikro-hizli-satis-486"
  }, {
    path: "/surec-yonetimi-porkod",
    component: _d6aa06ae,
    name: "surec-yonetimi-porkod-327"
  }, {
    path: "/mukellefini-getir",
    component: _d6aa06ae,
    name: "mukellefini-getir-472"
  }, {
    path: "/dikey-cozumler-indirim-kampanyasi-depo",
    component: _d6aa06ae,
    name: "dikey-cozumler-indirim-kampanyasi-depo-9"
  }, {
    path: "/mikro-depo-yonetimi-yazilimi",
    component: _d6aa06ae,
    name: "mikro-depo-yonetimi-yazilimi-418"
  }, {
    path: "/arkadasini-getir",
    component: _d6aa06ae,
    name: "arkadasini-getir-479"
  }, {
    path: "/dikey-cozumler-indirim-kampanyasi-satis",
    component: _d6aa06ae,
    name: "dikey-cozumler-indirim-kampanyasi-satis-145"
  }, {
    path: "/kurumsal-kaynak-planlama-sistem-ve-yazilimi",
    component: _d6aa06ae,
    name: "kurumsal-kaynak-planlama-sistem-ve-yazilimi-177"
  }, {
    path: "/jump-bulut-mikro",
    component: _d6aa06ae,
    name: "jump-bulut-mikro-337"
  }, {
    path: "/surec-yonetimi-ve-takibi",
    component: _d6aa06ae,
    name: "surec-yonetimi-ve-takibi-236"
  }, {
    path: "/erp-programi-mikro",
    component: _d6aa06ae,
    name: "erp-programi-mikro-66"
  }, {
    path: "/mikro-online-hesabim-video",
    component: _d6aa06ae,
    name: "mikro-online-hesabim-video-308"
  }, {
    path: "/cari-hesap-programi-mikro",
    component: _d6aa06ae,
    name: "cari-hesap-programi-mikro-184"
  }, {
    path: "/axtardiniz-hell-burada",
    component: _d6aa06ae,
    name: "axtardiniz-hell-burada-227"
  }, {
    path: "/bulut-muhasebe-mikro",
    component: _d6aa06ae,
    name: "bulut-muhasebe-mikro-291"
  }, {
    path: "/mikro-muhasebe-programi",
    component: _d6aa06ae,
    name: "mikro-muhasebe-programi-71"
  }, {
    path: "/mikro-online-muhasebe",
    component: _d6aa06ae,
    name: "mikro-online-muhasebe-473"
  }, {
    path: "/mikro-web-tabanli-stok-takibi",
    component: _d6aa06ae,
    name: "mikro-web-tabanli-stok-takibi-455"
  }, {
    path: "/hakkimizda",
    component: _699a505f,
    name: "hakkimizda-336"
  }, {
    path: "/gizlilik-bildirgesi",
    component: _699a505f,
    name: "gizlilik-bildirgesi-370"
  }, {
    path: "/kalite-yonetim-sistemi-politikamiz-1",
    component: _699a505f,
    name: "kalite-yonetim-sistemi-politikamiz-1-325"
  }, {
    path: "/bulut-cozumleri",
    component: _699a505f,
    name: "bulut-cozumleri-294"
  }, {
    path: "/sertifikalarimiz",
    component: _699a505f,
    name: "sertifikalarimiz-85"
  }, {
    path: "/yurt-disi-kvkk-metni",
    component: _699a505f,
    name: "yurt-disi-kvkk-metni-58"
  }, {
    path: "/fiyat-listesi",
    component: _699a505f,
    name: "fiyat-listesi-469"
  }, {
    path: "/kvkk-acik-riza-formu",
    component: _699a505f,
    name: "kvkk-acik-riza-formu-257"
  }, {
    path: "/kisisel-verilerin-islenmesi-hakkinda-ayinlatma-metni",
    component: _699a505f,
    name: "kisisel-verilerin-islenmesi-hakkinda-ayinlatma-metni-272"
  }, {
    path: "/ornek-paket-fiyatlari",
    component: _699a505f,
    name: "ornek-paket-fiyatlari-49"
  }, {
    path: "/hesaplama-araclari",
    component: _2570bee5,
    name: "hesaplama-araclari-305"
  }, {
    path: "/site-haritasi",
    component: _be3c97e0,
    name: "site-haritasi-5"
  }, {
    path: "/tesekkurler",
    component: _fbf08412,
    name: "tesekkurler-258"
  }, {
    path: "/ucretsiz-demo-talep",
    component: _3a922e46,
    name: "ucretsiz-demo-talep-22"
  }, {
    path: "/kampanyalar",
    component: _4268073e,
    name: "kampanyalar-488"
  }, {
    path: "/duyurular",
    component: _c6483aae,
    name: "duyurular-58"
  }, {
    path: "/mikro-yazilim-satis-sonrasi-destek",
    component: _d773d390,
    name: "mikro-yazilim-satis-sonrasi-destek-330"
  }, {
    path: "/mikro-yazilim-destek",
    component: _b334cf10,
    name: "mikro-yazilim-destek-463"
  }, {
    path: "/surum-guncellemeleri-hs",
    component: _11e29cdd,
    name: "surum-guncellemeleri-hs-430"
  }, {
    path: "/surum-guncellemeleri-v17",
    component: _2dced710,
    name: "surum-guncellemeleri-v17-231"
  }, {
    path: "/surum-guncellemeleri-detaylari",
    component: _a364c082,
    name: "surum-guncellemeleri-detaylari-32"
  }, {
    path: "/surum-guncellemeleri",
    component: _c4c68b58,
    name: "surum-guncellemeleri-275"
  }, {
    path: "/dikey-cozumler",
    component: _e1be75d0,
    name: "dikey-cozumler-26"
  }, {
    path: "/fastsell-restoran-cozumu",
    component: _10483204,
    name: "fastsell-restoran-cozumu-219"
  }, {
    path: "/ussoft-raporlama-ve-analiz",
    component: _10483204,
    name: "ussoft-raporlama-ve-analiz-279"
  }, {
    path: "/ussoft-depo-ve-lojistik-yonetimi",
    component: _10483204,
    name: "ussoft-depo-ve-lojistik-yonetimi-246"
  }, {
    path: "/is-degerlendirme-ve-ucret-yonetimi-cozumu",
    component: _10483204,
    name: "is-degerlendirme-ve-ucret-yonetimi-cozumu-402"
  }, {
    path: "/ussoft-kalite-yonetimi",
    component: _10483204,
    name: "ussoft-kalite-yonetimi-23"
  }, {
    path: "/porkod-surec-yonetimi-cozumu",
    component: _10483204,
    name: "porkod-surec-yonetimi-cozumu-11"
  }, {
    path: "/B2BSOFT-b2b-b4b-bayi-yonetimi",
    component: _10483204,
    name: "B2BSOFT-b2b-b4b-bayi-yonetimi-340"
  }, {
    path: "/eryaz-b2b-b4b",
    component: _10483204,
    name: "eryaz-b2b-b4b-86"
  }, {
    path: "/zeus-WMS",
    component: _10483204,
    name: "zeus-WMS-80"
  }, {
    path: "/proje-santiye-yonetim-cozumu",
    component: _10483204,
    name: "proje-santiye-yonetim-cozumu-282"
  }, {
    path: "/ussoft-uretim-yonetimi",
    component: _10483204,
    name: "ussoft-uretim-yonetimi-191"
  }, {
    path: "/mizan-hizli-satis",
    component: _10483204,
    name: "mizan-hizli-satis-30"
  }, {
    path: "/figopara-entegrasyonu",
    component: _10483204,
    name: "figopara-entegrasyonu-251"
  }, {
    path: "/getircarsi-isletme-yonetimi",
    component: _10483204,
    name: "getircarsi-isletme-yonetimi-454"
  }, {
    path: "/hosting-hizmeti",
    component: _10483204,
    name: "hosting-hizmeti-191"
  }, {
    path: "/mikro-e-ticaret",
    component: _10483204,
    name: "mikro-e-ticaret-350"
  }, {
    path: "/isletme-yonetimi-cozumleri",
    component: _10483204,
    name: "isletme-yonetimi-cozumleri-185"
  }, {
    path: "/mikro-online-hesabim",
    component: _10483204,
    name: "mikro-online-hesabim-379"
  }, {
    path: "/porkod-patron-ekrani-cozumu",
    component: _10483204,
    name: "porkod-patron-ekrani-cozumu-2"
  }, {
    path: "/fastsell-hizli-satis-cozumu",
    component: _10483204,
    name: "fastsell-hizli-satis-cozumu-37"
  }, {
    path: "/masraff",
    component: _10483204,
    name: "masraff-381"
  }, {
    path: "/nitrogen-depo-yonetimi-cozumu",
    component: _10483204,
    name: "nitrogen-depo-yonetimi-cozumu-476"
  }, {
    path: "/tam-finans-mobil-entegrasyon",
    component: _10483204,
    name: "tam-finans-mobil-entegrasyon-23"
  }, {
    path: "/faturalab",
    component: _10483204,
    name: "faturalab-476"
  }, {
    path: "/mikro-hizli-satis",
    component: _10483204,
    name: "mikro-hizli-satis-18"
  }, {
    path: "/mikro-sirketim",
    component: _10483204,
    name: "mikro-sirketim-460"
  }, {
    path: "/sektorel-cozumler",
    component: _10483204,
    name: "sektorel-cozumler-18"
  }, {
    path: "/mikro-drive",
    component: _10483204,
    name: "mikro-drive-217"
  }, {
    path: "/entegrasyon-programlari",
    component: _10483204,
    name: "entegrasyon-programlari-453"
  }, {
    path: "/express-aktarim",
    component: _10483204,
    name: "express-aktarim-162"
  }, {
    path: "/veribis-crm",
    component: _10483204,
    name: "veribis-crm-464"
  }, {
    path: "/asistan-guncelleme",
    component: _10483204,
    name: "asistan-guncelleme-203"
  }, {
    path: "/cozumler",
    component: _13990f35,
    name: "cozumler-91"
  }, {
    path: "/is-ortaklari/is-ortaklarimiz",
    component: _5f3a2e5e,
    name: "is-ortaklari-is-ortaklarimiz-52"
  }, {
    path: "/is-ortaklari/is-ortaklari-kaynaklari",
    component: _639d55d8,
    name: "is-ortaklari-is-ortaklari-kaynaklari-33"
  }, {
    path: "/is-ortaklari/is-ortaklari-programi",
    component: _62ae37b3,
    name: "is-ortaklari-is-ortaklari-programi-28"
  }, {
    path: "/hakkimizda/mikro-kurumsal-kimlik",
    component: _52a2cdc0,
    name: "hakkimizda-mikro-kurumsal-kimlik-249"
  }, {
    path: "/is-ortaklari/kurumsal-kimlik",
    component: _0afed065,
    name: "is-ortaklari-kurumsal-kimlik-91"
  }, {
    path: "/mikro-program-api-basvuru",
    component: _4a561816,
    name: "mikro-program-api-basvuru-455"
  }, {
    path: "/mikro-api-talep-formu",
    component: _2d27f376,
    name: "mikro-api-talep-formu-11"
  }, {
    path: "/is-ortaklari/is-ortagi-basvuru-formu",
    component: _11c9d7b6,
    name: "is-ortaklari-is-ortagi-basvuru-formu-321"
  }, {
    path: "/yasal",
    component: _589c5514,
    name: "yasal-147"
  }, {
    path: "/e-donusum-urunleri",
    component: _3423a28e,
    name: "e-donusum-urunleri-403"
  }, {
    path: "/sirket-tipine-gore-mikro",
    component: _249a739e,
    name: "sirket-tipine-gore-mikro-475"
  }, {
    path: "/sektorel-muhasebe-programi",
    component: _0b0091ac,
    name: "sektorel-muhasebe-programi-143"
  }, {
    path: "/ihtiyaca-gore-mikro/page/12",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/12-440"
  }, {
    path: "/ihtiyaca-gore-mikro/page/11",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/11-87"
  }, {
    path: "/ihtiyaca-gore-mikro/page/10",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/10-280"
  }, {
    path: "/ihtiyaca-gore-mikro/page/9",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/9-381"
  }, {
    path: "/ihtiyaca-gore-mikro/page/8",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/8-361"
  }, {
    path: "/ihtiyaca-gore-mikro/page/7",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/7-368"
  }, {
    path: "/ihtiyaca-gore-mikro/page/6",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/6-338"
  }, {
    path: "/ihtiyaca-gore-mikro/page/5",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/5-358"
  }, {
    path: "/ihtiyaca-gore-mikro/page/4",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/4-353"
  }, {
    path: "/ihtiyaca-gore-mikro/page/3",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/3-288"
  }, {
    path: "/ihtiyaca-gore-mikro/page/2",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/2-198"
  }, {
    path: "/ihtiyaca-gore-mikro/page/1",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-page/1-492"
  }, {
    path: "/ihtiyaca-gore-mikro",
    component: _225fc774,
    name: "ihtiyaca-gore-mikro-58"
  }, {
    path: "/urun-karsilastirma",
    component: _2adb6382,
    name: "urun-karsilastirma-58"
  }, {
    path: "/iletisim",
    component: _355b21bb,
    name: "iletisim-471"
  }, {
    path: "/hakkimizda/mikro-yazilimda-kariyer",
    component: _0bd165f0,
    name: "hakkimizda-mikro-yazilimda-kariyer-476"
  }, {
    path: "/hakkimizda/mikro-yazilimda-calismak",
    component: _1bb76077,
    name: "hakkimizda-mikro-yazilimda-calismak-215"
  }, {
    path: "/hakkimizda/insan-kaynaklari",
    component: _3ba25728,
    name: "hakkimizda-insan-kaynaklari-455"
  }, {
    path: "/hakkimizda/basari-hikayeleri",
    component: _4336e7a7,
    name: "hakkimizda-basari-hikayeleri-76"
  }, {
    path: "/hakkimizda/buyuk-dusunenler",
    component: _905d5520,
    name: "hakkimizda-buyuk-dusunenler-415"
  }, {
    path: "/blog/page/61",
    component: _581c45bd,
    name: "blog-page/61-172"
  }, {
    path: "/blog/page/60",
    component: _581c45bd,
    name: "blog-page/60-313"
  }, {
    path: "/blog/page/59",
    component: _581c45bd,
    name: "blog-page/59-431"
  }, {
    path: "/blog/page/58",
    component: _581c45bd,
    name: "blog-page/58-387"
  }, {
    path: "/blog/page/57",
    component: _581c45bd,
    name: "blog-page/57-231"
  }, {
    path: "/blog/page/56",
    component: _581c45bd,
    name: "blog-page/56-98"
  }, {
    path: "/blog/page/55",
    component: _581c45bd,
    name: "blog-page/55-384"
  }, {
    path: "/blog/page/54",
    component: _581c45bd,
    name: "blog-page/54-171"
  }, {
    path: "/blog/page/53",
    component: _581c45bd,
    name: "blog-page/53-359"
  }, {
    path: "/blog/page/52",
    component: _581c45bd,
    name: "blog-page/52-8"
  }, {
    path: "/blog/page/51",
    component: _581c45bd,
    name: "blog-page/51-359"
  }, {
    path: "/blog/page/50",
    component: _581c45bd,
    name: "blog-page/50-417"
  }, {
    path: "/blog/page/49",
    component: _581c45bd,
    name: "blog-page/49-36"
  }, {
    path: "/blog/page/48",
    component: _581c45bd,
    name: "blog-page/48-247"
  }, {
    path: "/blog/page/47",
    component: _581c45bd,
    name: "blog-page/47-202"
  }, {
    path: "/blog/page/46",
    component: _581c45bd,
    name: "blog-page/46-107"
  }, {
    path: "/blog/page/45",
    component: _581c45bd,
    name: "blog-page/45-421"
  }, {
    path: "/blog/page/44",
    component: _581c45bd,
    name: "blog-page/44-214"
  }, {
    path: "/blog/page/43",
    component: _581c45bd,
    name: "blog-page/43-83"
  }, {
    path: "/blog/page/42",
    component: _581c45bd,
    name: "blog-page/42-281"
  }, {
    path: "/blog/page/41",
    component: _581c45bd,
    name: "blog-page/41-205"
  }, {
    path: "/blog/page/40",
    component: _581c45bd,
    name: "blog-page/40-416"
  }, {
    path: "/blog/page/39",
    component: _581c45bd,
    name: "blog-page/39-183"
  }, {
    path: "/blog/page/38",
    component: _581c45bd,
    name: "blog-page/38-145"
  }, {
    path: "/blog/page/37",
    component: _581c45bd,
    name: "blog-page/37-109"
  }, {
    path: "/blog/page/36",
    component: _581c45bd,
    name: "blog-page/36-456"
  }, {
    path: "/blog/page/35",
    component: _581c45bd,
    name: "blog-page/35-166"
  }, {
    path: "/blog/page/34",
    component: _581c45bd,
    name: "blog-page/34-450"
  }, {
    path: "/blog/page/33",
    component: _581c45bd,
    name: "blog-page/33-155"
  }, {
    path: "/blog/page/32",
    component: _581c45bd,
    name: "blog-page/32-435"
  }, {
    path: "/blog/page/31",
    component: _581c45bd,
    name: "blog-page/31-440"
  }, {
    path: "/blog/page/30",
    component: _581c45bd,
    name: "blog-page/30-134"
  }, {
    path: "/blog/page/29",
    component: _581c45bd,
    name: "blog-page/29-130"
  }, {
    path: "/blog/page/28",
    component: _581c45bd,
    name: "blog-page/28-232"
  }, {
    path: "/blog/page/27",
    component: _581c45bd,
    name: "blog-page/27-463"
  }, {
    path: "/blog/page/26",
    component: _581c45bd,
    name: "blog-page/26-386"
  }, {
    path: "/blog/page/25",
    component: _581c45bd,
    name: "blog-page/25-410"
  }, {
    path: "/blog/page/24",
    component: _581c45bd,
    name: "blog-page/24-368"
  }, {
    path: "/blog/page/23",
    component: _581c45bd,
    name: "blog-page/23-86"
  }, {
    path: "/blog/page/22",
    component: _581c45bd,
    name: "blog-page/22-315"
  }, {
    path: "/blog/page/21",
    component: _581c45bd,
    name: "blog-page/21-80"
  }, {
    path: "/blog/page/20",
    component: _581c45bd,
    name: "blog-page/20-62"
  }, {
    path: "/blog/page/19",
    component: _581c45bd,
    name: "blog-page/19-323"
  }, {
    path: "/blog/page/18",
    component: _581c45bd,
    name: "blog-page/18-246"
  }, {
    path: "/blog/page/17",
    component: _581c45bd,
    name: "blog-page/17-276"
  }, {
    path: "/blog/page/16",
    component: _581c45bd,
    name: "blog-page/16-62"
  }, {
    path: "/blog/page/15",
    component: _581c45bd,
    name: "blog-page/15-443"
  }, {
    path: "/blog/page/14",
    component: _581c45bd,
    name: "blog-page/14-169"
  }, {
    path: "/blog/page/13",
    component: _581c45bd,
    name: "blog-page/13-216"
  }, {
    path: "/blog/page/12",
    component: _581c45bd,
    name: "blog-page/12-353"
  }, {
    path: "/blog/page/11",
    component: _581c45bd,
    name: "blog-page/11-107"
  }, {
    path: "/blog/page/10",
    component: _581c45bd,
    name: "blog-page/10-220"
  }, {
    path: "/blog/page/9",
    component: _581c45bd,
    name: "blog-page/9-19"
  }, {
    path: "/blog/page/8",
    component: _581c45bd,
    name: "blog-page/8-387"
  }, {
    path: "/blog/page/7",
    component: _581c45bd,
    name: "blog-page/7-74"
  }, {
    path: "/blog/page/6",
    component: _581c45bd,
    name: "blog-page/6-1"
  }, {
    path: "/blog/page/5",
    component: _581c45bd,
    name: "blog-page/5-394"
  }, {
    path: "/blog/page/4",
    component: _581c45bd,
    name: "blog-page/4-250"
  }, {
    path: "/blog/page/3",
    component: _581c45bd,
    name: "blog-page/3-304"
  }, {
    path: "/blog/page/2",
    component: _581c45bd,
    name: "blog-page/2-283"
  }, {
    path: "/blog/page/1",
    component: _581c45bd,
    name: "blog-page/1-282"
  }, {
    path: "/blog/search",
    component: _572b4b4d,
    name: "blog-search/-388"
  }, {
    path: "/blog",
    component: _581c45bd,
    name: "blog-401"
  }, {
    path: "/hakkimizda/surdurulebilirlik",
    component: _20762fe0,
    name: "hakkimizda-surdurulebilirlik-267"
  }, {
    path: "/hakkimizda/musteri-takintililik",
    component: _8818fdcc,
    name: "hakkimizda-musteri-takintililik-339"
  }, {
    path: "/neden-mikro-yazilim",
    component: _2e070f62,
    name: "neden-mikro-yazilim-151"
  }, {
    path: "/",
    component: _add53e2c,
    name: "--109"
  }, {
    path: "/search",
    component: _c02ce4a6,
    name: "search"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
